export const lang = {
    get: (string, parameters?) => {
        switch (string) {
            // Integrations + Fortnox (Z): MACHINE-TRANSLATED from Swedish, needs native-Danish review (language.dk-no.REVIEW.md)
            case 'INTEG_INTRO': return `Aktivér og administrer tilføjelser for ${parameters[0]}.`;
            case 'INTEG_CONNECTED_TO': return `Forbundet til ${parameters[0]}`;
            case 'INTEG_CONNECTED_TO_AUTO': return `Forbundet til ${parameters[0]} · automatisk eksport slået til`;
            case 'INTEG_STATUS_FAILED': return `Status kunne ikke hentes (${parameters[0]})`;
            case 'FZ_NOTICE_ORG_MISMATCH': return `Forkert virksomhed: Fortnox-kontoen tilhører ${parameters[0]} (${parameters[1]}), men restauranten tilhører ${parameters[2]}. Intet blev gemt.`;
            case 'FZ_NOTICE_DENIED': return `Forbindelsen blev afbrudt i Fortnox: ${parameters[0]}`;
            case 'FZ_NOTICE_ERROR': return `Forbindelsen mislykkedes: ${parameters[0]}`;
            case 'FZ_CONNECTED_META': return `forbundet ${parameters[0]} af ${parameters[1]}`;
            case 'FZ_SCOPE_NOTE': return `Forbindelsen gælder alle restauranter, der tilhører ${parameters[0]}. Indstillingerne nedenfor gælder kun ${parameters[1]}.`;
            case 'FZ_ORG_MISMATCH_WARN': return `Restaurantens virksomhed i PubQ har CVR-nr. ${parameters[0]}, men er forbundet til ${parameters[1]}.`;
            case 'FZ_REAUTH_WARN': return `Fortnox-forbindelsen for ${parameters[0]} er udløbet og skal godkendes igen.`;
            case 'FZ_ALREADY_CONNECTED': return `Virksomheden ${parameters[0]} er allerede forbundet – restauranten er nu tilknyttet.`;
            case 'FZ_SETTINGS_FOR': return `Indstillinger for ${parameters[0]}`;
            case 'FZ_FROM_Z': return `fra Z ${parameters[0]}`;
            case 'FZ_EG': return `f.eks. ${parameters[0]}`;
            case 'FZ_APPROVED_SO_FAR': return `${parameters[0]} bogført indtil videre`;
            case 'FZ_PREVIEW_TITLE': return `Bilag for Z ${parameters[0]}`;
            case 'FZ_SERIES_X': return `serie ${parameters[0]}`;
            case 'FZ_PREVIEW_SUMMARY': return `${parameters[0]} kvitteringer · Z-rapportens total ${parameters[1]} kr`;
            case 'FZ_DROPPED': return `${parameters[0]} nullinje(r) udeladt`;
            case 'FZ_RESEND_TITLE': return `Send Z ${parameters[0]} igen?`;
            case 'FZ_RESEND_ALREADY': return `Z ${parameters[0]} er allerede bogført.`;
            case 'FZ_RESEND_ALREADY_AS': return `Z ${parameters[0]} er allerede bogført som ${parameters[1]}.`;
            case 'FZ_DISCONNECT_ALL': return `Dette afbryder Fortnox for alle restauranter, der tilhører ${parameters[0]}.`;
            case 'FZ_TOAST_SENT': return `Z ${parameters[0]} bogført`;
            case 'FZ_TOAST_SENT_AS': return `Z ${parameters[0]} bogført som ${parameters[1]}`;
            case 'FZ_TOAST_NOT_SENT': return `Z ${parameters[0]} blev ikke sendt`;
            case 'FZ_BACKFILL_RESULT': return `Eftersendt: ${parameters[0]} bogført, ${parameters[1]} ikke`;
            case 'FZ_BACKFILL_STOPPED': return `Stoppede ved Z ${parameters[0]}: ${parameters[1]}`;
            case 'FZ_ERR_SECTION_TIMEOUT': return `Fortnox-tjenesten svarede ikke inden for ${parameters[0]} s`;
            case 'FZ_ERR_SIGNIN_TIMEOUT': return `Login svarede ikke inden for ${parameters[0]} s`;
            case 'FZ_CUST_REFRESHED': return `Opdateret fra Fortnox: ${parameters[0]} felter ændret.`;
            case 'CARD_ADDED_FOR': return `'Kort oprettet til`;
            case 'REMOVE_NAME': return `'Fjern ${parameters[0]} ?`;
            case 'REMOVED_IMAGE': return `'${parameters[0]} fjernet`;
            case 'PRODUCTS_UPDATED': return `'${parameters[0]} produkter opdateret`;
            case 'UPDATING_PRODUCTS_PROGRESS': return `Opdaterer produkter ${parameters[0]} af ${parameters[1]}`;
            case 'SAVING_MENU': return `'Gemmer menu til ${parameters[0]}`;
            case 'REMOVE_MENU': return `'Fjern ${parameters[0]} ?`;
            case 'SAVING_GALLERY': return `'Gemmer galleri til ${parameters[0]}`;
            case 'REMOVED_IMAGE': return `'${parameters[0]} fjernet`;
            case 'NUMBER_ARTICLES': return `'${parameters[0]} artikler`;
            case 'UPDATE_ITEM': return `'Opdateret ${parameters[0]}`;
            case 'PRODUCT_ADDED': return `'${parameters[0]} lagt til`;
            case 'PRODUCT_REMOVED': return `'${parameters[0]} fjernet`;
            case 'REMOVE_PRODUCT_CATEGORY': return `'Vil du fjerne ${parameters[0]} ?`;
            case 'REMOVE_BONG_CATEGORY': return `'Vil du fjerne ${parameters[0]} ?`;
            case 'SHARE_NEWS_WITH': return `'Deler nyheden med ${parameters[0]}`;
            case 'NEWS_SHARED': return `'Delte ${parameters[0]}`;
            case 'TIMELINE_SAVED_FOR': return `'Gemmer tidslinjen for ${parameters[0]}`;
            case 'SHARING_OFFER_WITH': return `'Deler tilbuddet med ${parameters[0]}`;
            case 'OFFER_SHARED': return `'Delte ${parameters[0]}`;
            case 'REMOVE_COUPON': return `'Fjern ${parameters[0]} ?`;
            case 'LINKED_PRODUCT': return `'Tilknyttet ${parameters[0]}`;
            case 'COPY_FROM': return `'Kopiere fra ${parameters[0]} ?`;
            case 'REMOVE': return `'Fjern ${parameters[0]} ?`;
            case 'REMOVE_CORPORATE_USER_QUESTION': return `Er du sikker på, at du vil fjerne ${parameters[0]}?`;
            case 'REMOVING': return `'Fjerner ${parameters[0]}`;
            case 'ADDED': return `'Føjer til ${parameters[0]}`;
            case 'PRODUCT_SAVED': return `'${parameters[0]} er gemt`;
            case 'SAVING_PRODUCT': return `'Gemmer produkt for ${parameters[0]}`;
            case 'CONFIRM_REMOVE_ACCOUNTING': return `'Er du sikker på at du vil slette ?`;
            case 'REMOVE_ACCOUNTING': return `'${parameters[0]} fjernet`;
            case 'SAVED': return `'Gemte ${parameters[0]}`;
            case 'RECEIPTS_AMOUNT': return `Totalt: ${parameters[0]} kvitton & ${parameters[1]}`;//translate
            default: return '';
        }
    },
    ALCOHOL_STRINGS: ["vin", "shot", "drink", "sprit", "cognac", "öl", "cider", "whisk", "whiskey", "whisky", "rom", "likör", "vodka", "limoncello", "alkoläsk"],
    AMOUNT_MIN_MOBILE_WALLET: 'Minimum',
    AMOUNT_1_MOBILE_WALLET: 'Beløb 1',
    AMOUNT_2_MOBILE_WALLET: 'Beløb 2',
    STRINGS: ["Öl", "Vin", "Alkoholfritt", "Mat", "Cider", "Drink", "Sprit", "Dricks", "Presentkort"],
    DRINK_LIST: ["dricka", "dryck"],
    WEEL_LIST: ["Sön", "Mån", "Tis", "Ons", "Tors", "Fre", "Lör"],
    CHOSE_PRINTER: 'Vælg printer',
    SAVE_AS_PDF: 'Gem som PDF',
    MY_ACCOUNT: 'Min konto',
    USER_ID: 'BrugerID',

    PROFILE: 'Profil',
    ADD_INFO_TO_PROFILE: 'Tilføj oplysninger til din profil, så vi bedre kan støtte dig på denne rejse.',
    PLEASE_ENTER_ADDRESS: 'Indtast venligst din adresse',
    FIRST_NAME: 'Fornavn',
    LAST_NAME: 'Efternavn',
    POSTCODE: 'Postnummer',
    CITY: 'By',
    COUNTRY: 'Land',
    NEXT_STEP: 'Næste skridt',

    ORGANIZATION: 'Organisation',
    ENTER_ORG_INFO: 'Indtast din organisationsoplysninger.',
    ENTER_COMPANY_NAME: 'Indtast venligst et firmanavn',
    VALIDATE: 'VALIDER',
    VALIDATING: 'VALIDERING',
    VALIDATED: 'VALIDERET',
    PREVIOUS: 'Forrige',

    REVIEW_DETAILS_SUBMIT: 'Gennemgå dine detaljer og indsend',
    WIZARD3_TEXT1: 'Nu er vi næsten igennem registreringsdelen, dobbelttjek dine oplysninger nedenfor.',
    WIZARD3_TEXT2: 'Så kan du begynde at udforske PubQ-platformen.',
    WIZARD3_TEXT3: 'Der oprettes et nyt firma med navnet',

    FREE_REGISTER: 'Gratis registrering for at komme i gang',
    STEP: 'Trin',

    SIGNUP: 'Tilmelde',
    CREATE_ACC_DETAILS: 'Indtast dine oplysninger for at oprette din konto',
    FULLNAME: 'Fulde navn',
    IS_REQUIRED: 'er påkrævet',
    CONFIRM_PASSWORD: 'Bekræft kodeord',
    REGISTER: 'Tilmeld',
    LOG_OUT: 'Log ud',
    HANDLE_PERSONNELCARD: 'Hent personalekort',
    CREATE_NEW_CARD: 'Opret nyt kort',
    PERSONNELCARD: 'Personalekort',
    NAME: 'Navn',
    NAME_REQUIRED: 'Navn er påkrævet.',
    TEXT_ON_CARD: 'Tekst på kort',
    AVAILABLE_THROUGH: 'Gyldig til',
    URL_TO_BACKGROUND: 'URL til baggrund',
    REMOVE: 'Fjern',
    SAVE: 'Gem',
    SEARCH: 'Søg',
    SEARCH_IMAGE: 'Søg billede...',
    SEARCH_VIDEO: 'Søg video...',
    BACK: 'Tilbage',
    UNIT_SWITCHER_SEARCH_UNITS: 'Søg enheder efter navn eller ID',
    UNIT_SWITCHER_SELECT: 'for at vælge',
    UNIT_SWITCHER_OPEN: 'for at åbne',
    UNIT_SWITCHER_CLOSE: 'for at lukke',
    UNIT_SWITCHER_NO_RESULTS: 'Ingen enheder fundet',
    USER_WITH_CARD: 'Brugere med kort',
    ID: 'ID',
    CARD: 'Kort',
    JANUARY: 'Januar',
    FEBRUARY: 'Februar',
    MARS: 'Marts',
    APRIL: 'April',
    MAY: 'Mej',
    JUNE: 'Juni',
    JULY: 'Juli',
    AUGUST: 'August',
    SEPTEMBER: 'September',
    OCTOBER: 'Oktober',
    NOVEMBER: 'November',
    DECEMBER: 'December',
    JAN3: 'Jan',
    FEB3: 'Feb',
    MAR3: 'Mar',
    APR3: 'Apr',
    MAY3: 'Maj',
    JUN3: 'Jun',
    JUL3: 'Jul',
    AUG3: 'Aug',
    SEP3: 'Sep',
    OCT3: 'Okt',
    NOV3: 'Nov',
    DEC3: 'Dec',
    OK: 'Ok',
    AUTHORIZED_USERS: 'Autoriserede brugere',
    ADD_NEW_USER: 'Tilføj ny bruger',
    NO_AUTHORIZED_USERS: 'Ingen autoriserede brugere endnu.',
    ENTER_USER_NAME: 'Indtast brugernavn',
    ENTER_USER_EMAIL: 'Indtast brugerens e-mail',
    CORPORATE_USER_INVITED: 'Autoriseret bruger inviteret.',
    RESEND_INVITATION: 'Send invitation igen',
    CORPORATE_USER_INVITATION_RESENT: 'Invitationen blev sendt igen.',
    CORPORATE_USER_INVITATION_RESEND_FAILED: 'Kunne ikke sende invitationen igen.',
    CORPORATE_USER_ALREADY_LINKED: 'Denne bruger er allerede knyttet til denne virksomhed for denne lokation.',
    CORPORATE_USER_REMOVED: 'Autoriseret bruger fjernet.',
    CORPORATE_USER_REMOVE_FAILED: 'Kunne ikke fjerne autoriseret bruger.',
    FAILED_TO_LOAD_AUTHORIZED_USERS: 'Kunne ikke indlæse autoriserede brugere.',

    USERNAME: 'BRUGERNAVN',
    DATE: 'DATO',
    ORDER_NAME: 'BESTILLINGSNAVN',
    TOTAL_ITEMS: 'SAMLEDE ARTIKLER',
    ADDRESS: 'Adresse',
    ACTIONS: 'HANDLINGER',
    PLACE_ORDER: 'Angiv bestilling',
    CANCEL: 'Afbryd',
    SCHEDULE_VIEW: 'Skemavisning',
    SORTED_ON_PRODUCT: 'Sorteret på produkt',
    DAY: 'Dag',
    TOTAL: 'Total',
    ORDERS_TODAY: 'Ordrer i dag',
    ORDERS_THIS_MONTH: 'Ordrer denne måned',
    ACTIVITY: 'Aktivitet',
    COUPONS_IN_APP: 'Kuponer brugt i appen',
    PER_PRODUCT: 'Pr. produkt',
    USERS_WITH_CODES: 'Brugere med rabatkoder',
    RECEIPTNO: 'Kvitteringsnr',
    TIME: 'Tid',
    CODE: 'Kode',
    ORDERCODE: 'Ordrekode',
    NAVIGATE_HERE: 'Naviger her eller benyt menuen oppe til venstre',
    UPLOADING: 'Lader op',
    UPLOAD: 'Oplad',
    GALLERY: 'Galleri',
    GALLERY_IMAGE_LOAD_FAILED: 'Billedet kunne ikke indlæses',
    GALLERY_RETRY: 'Prøv igen',
    GALLERY_SHOW_MORE: 'Vis flere',
    GALLERY_IMAGE_REMOVED: 'Billedet blev fjernet',
    GALLERY_VIDEO_REMOVED: 'Videoen blev fjernet',
    DELETE_IMAGE: 'Slet billede',
    ARE_YOU_SURE_GALLERY: 'Er du sikker på, at du vil fjerne billedet fra galleriet?',
    ARE_YOU_SURE: 'Er du sikker ?',
    UPDATING_IMAGE_QUICK: 'Vent … vi opdaterer dit billede',
    SYNC_PRODUCTS: 'Synkroniser produkter',
    CLEAR_EXISTING_PROUCTS: 'Ryd eksisterende produkter ?',
    UPDATING_PRODUCTS: 'Opdaterer produkter',
    SAVING_OPTION_GROUP: 'Gemmer tillægsgruppe…',
    OPT_GROUP_SAVE_FAILED: 'Tillægsgruppen kunne ikke gemmes.',
    PRODUCT_PAGE_VERIFY: 'Gå til produktsiden for at verificere',
    FROM: 'Fra',
    TO: 'Til',
    ORDERVALUE_COUPON: 'Ordresum med kuponkode',
    SUM_RECEPITS_COUPON: 'Summen af ​​kvitteringer, hvor gæsten handlede med en kuponkode',
    CODE_CAPS: 'KODE',
    DISCOUNT_CAPS: 'RABAT',
    NETTO_CAPS: 'NETTO',
    VAT_CAPS: 'MOMS',
    TOTAL_CAPS: 'TOTAL',
    TODAY_CAPS: 'I DAG',
    CLOSE_CAPS: 'LUK',
    RESET_FORTNOX: 'Gendan Fortnox-forbindelsen?',
    RESET_FORTNOX_TEXT: 'Er du sikker på, at du vil fjerne Fortnox-forbindelsen og gendanne det, så der kan oprettes en ny forbindelse ?',
    NO: 'Nej',
    YES: 'Ja',
    AUTHORIZATIONCODE: 'Autorisationskode',
    AUTHORIZED: 'Godkendt',
    VOUCHER_SERIES: 'Verifikationsserie',
    ROUNDING_ACCOUNT: 'Konto for øreafrunding',
    ACTIVATE: 'Aktivere',
    INTEGRATIONS: 'integrationer',
    PASSWORD: 'Kodeord',
    FORWARD: 'Videre',
    FORGOT_PASSWORD: 'Glemt kodeord ?',
    RESET_EMAIL_HEAD: 'Email til nulstilling',
    RESET_EMAIL_TXT: 'Udfyld med din email adresse',
    NEW_MENU: 'Ny menu',
    COPY: 'kopier',
    SURE: 'Er du sikker ?',
    MENU_SHARED: 'Del menuen !',
    SOMETHING_WRONG: 'Der skete en fejl !',
    ACTIVATE_BEFORE_REMOVE: 'Du skal aktivere en anden menu før du kan fjerne denne',
    REMOVE_FOR_ALL: 'Fjern for alle ?',
    REMOVE_EVEN_OTHERS: 'Vil du også slette oplægget, hvis det findes på andre restaurantenheder? ',
    REMOVED_FROM_ALL: 'Fjern fra alle restauranter',
    MONDAY: 'Mandag',
    TUESDAY: 'Tirsdag',
    WEDNESDAY: 'Onsdag',
    THURSDAY: 'Torsdag',
    FRIDAY: 'Fredag',
    SATURDAY: 'Lørdag',
    SUNDAY: 'Søndag',
    FAILED: 'Fejlet',
    ERROR: 'Fejl',
    SAVED: 'Gemt !',
    MENUS: 'Menuer',
    VISIBLE_IN_APP: 'Synlig i appen',
    WEEKLY_MENU: 'Ugemenu',
    WEEKLY_MENU_PLANNER: 'Plan for ugemenu',
    WEEKLY_MENU_PLANNER_DESCRIPTION: 'Byg en ugentlig produktplan fra mandag til søndag.',
    GLOBAL_SETTINGS: 'Forudbestillingsgrænser',
    WEEKLY_MENU_GLOBAL_SETTINGS_DESCRIPTION: 'Vælg hvor mange dage i forvejen gæster kan bestille.',
    ORDER_DAYS_IN_ADVANCE: 'Kunder kan bestille så mange dage i forvejen',
    DAY_SETTINGS: 'Dagsindstillinger',
    SEARCH_PRODUCTS: 'Søg produkter',
    SEARCH_PRODUCT_REGISTER: 'Søg i produktregisteret',
    WEEKLY_MENU_PRODUCT: 'Ugemenu-produkt',
    WEEKLY_MENU_PRODUCT_HINT: 'Vis denne vare i produktregisteret til ugemenuen.',
    WEEKLY_MENU_PRICE_HELP: 'Valgfrit: lad feltet stå tomt for at bruge basisprisen for den serveringsmetode.',
    WEEKLY_MENU_AVAILABLE_THIS_DAY: 'Tilgængelig denne dag',
    WEEKLY_MENU_PRODUCT_ENABLED_EVERYWHERE_HINT: 'Når slået fra, skjules produktet overalt det bruges, ikke kun denne ugedag.',
    PRICE_OPTIONS: 'Prismuligheder',
    EAT_IN_PRICE: 'Pris for at spise her',
    TAKEAWAY_PRICE: 'Takeaway-pris',
    SHOW_IN_DRIVEDELIVERY: 'Vis for kørsellevering',
    SHOW_IN_FIXEDLOCATION: 'Vis for fast lokation',
    CLOSED_FOR_ORDERING: 'Lukket for bestilling',
    OPEN_FOR_ORDERING: 'Åben for bestilling',
    SERVING_OPTIONS: 'Serveringsmetoder',
    SERVING_OPTIONS_DESCRIPTION: 'Vælg hvilke serveringsmetoder der skal være tilgængelige i salgskanalerne',
    ENABLE_SERVING_METHOD: 'Administrer serveringsmetoder',
    ENABLE_SERVING_METHOD_DESCRIPTION: 'Når en serveringsmetode er aktiveret, kan gæster i salgskanalerne vælge den ved bestilling.',
    SERVING_OPTIONS_MENU: 'Vælg serveringsmetoder for ugemenu',
    SERVING_OPTIONS_MENU_EXPLANATION: 'Aktiver disse serveringsmetoder, når ugemenuen er aktiv',
    SERVING_OPTIONS_SAVED: 'Serveringsindstillinger gemt',
    EAT_IN: 'Spis her',
    DELIVERY_TO_FIXED_LOCATIONS: 'Levering til fast sted',
    DELIVERY_LOCATIONS: 'Leveringslokationer',
    NEW_DELIVERY_LOCATION: 'Ny leveringslokation',
    MINIMUM_FEE_OPTIONAL: 'Minimumsgebyr (valgfrit)',
    NO_LOCATIONS_ADDED: 'Ingen lokationer tilføjet endnu',
    ORDER_CUTOFF_TIME: 'Bestillingsfrist',
    AVAILABLE_FROM: 'Tilgængelig fra',
    AVAILABLE_UNTIL: 'Tilgængelig til',
    ORDERS_MUST_BE_PLACED_BEFORE_THIS_TIME: 'Bestillinger skal være lagt før dette tidspunkt.',
    SAVE_SETTINGS: 'Gem indstillinger',
    GLOBAL_SETTINGS_SAVED: 'Globale indstillinger gemt',
    SETTINGS_SAVED: 'Indstillinger gemt',
    SHOW_BUTTON: 'Vis knappen Ugentlig på appens startside. Opdater teksten ugentligt, så brugerne kan se, hvad der serveres ',
    UPLOAD_PROGRESS: 'Lader op',
    GALLERY_SHARED: 'Delt galleriet !',
    USE_IMAGE: 'Brug billede',
    USE_VIDEO: 'Brug video',
    PREVIEW_VIDEO: 'Forhåndsvis video',
    DELETE_VIDEO: 'Slet video',
    UPDATING_IMAGE: 'Vent … vi opdaterer dit billede',
    COMPRESSING: 'Komprimerer',
    HELP: 'Hjælp',
    IN_STOCK: 'På lager',
    OUT_OF_STOCK: 'Udsolgt',
    STOCK_BALANCE_ERROR: 'Lagersaldoen skal være større end 0',
    FEW_LEFT_IN_STOCK: 'Få tilbage på lager',
    CATEGORIES: 'Kategorier',
    FOOD: 'Mad',
    PRODUCTS: 'Produkter',
    ADD: 'Tilføj',
    UPDATE: 'Opdaterer',
    CONFIRM: 'OK',
    PRODUCT_CATEGORIES: 'Produktkategorier',
    BONG_CATEGORIES: 'Bonkategorier',
    NEW_PRODUCT_CATEGORY: 'Ny produktkategori',
    REMOVE_PRODUCT_CATEGORY: 'Fjern produktkategori',
    EDIT_PRODUCT_CATEGORY: 'Ændre produktkategori',
    NEW_BONG_CATEGORY: 'Ny bonkategorier',
    REMOVE_BONG_CATEGORY: 'Fjern bonkategorier',
    EDIT_BONG_CATEGORY: 'Ændre bonkategorier',
    COURSE: 'Ret',
    COURSE_NAME_1: 'Forret',
    COURSE_NAME_2: 'Hovedret',
    COURSE_NAME_3: 'Dessert',
    NO_COURSE: 'Ingen ret',
    NO_COURSE_DIRECT: 'Ingen ret (sendes med det samme)',
    COURSE_HINT: 'Kassen lægger varer i denne bonkategori i den valgte ret. Ingen ret: sendes til køkkenet med det samme.',
    TIMELINE: 'Tidslinje',
    NEW_POST: 'Ny post',
    SHARE: 'Del',
    CHOOSE_IMAGE: 'Vælg billede…',
    TITLE: 'Titel',
    TEXT: 'Tekst',
    OFFER: 'Tilbud',
    PRODUCT: 'Produkt',
    URL: 'URL',
    STATIC: 'Statisk',
    APP_TAB: 'Fane i appen som produktet ligger under',
    OFFER_INFO: 'Info om tilbud',
    WARNING: 'Advarsel',
    ALREADY_EDITING: 'Du redigerer allerede en anden post. Er du sikker på, at du vil miste data ?',
    ABORT_Q: 'Afbryd ?',
    CONFIRM_CHANGES: 'Er du sikker på at du vil afbryde ? Ændringer vil blive slettet',
    FILL_ALL_FIELDS: 'Du skal udfylde alle felter udover titel og tekst',
    SAVE_NEWS: 'Gemmer nyheder',
    MAIN_TEXT: 'Hovedtekst',
    NEW_TITLE: 'Ny titel',
    REMOVE_POST: 'Fjern indlæg ?',
    REMOVE_POST_CONFIRM: 'Er du sikker på at du vil fjerne indlægget ?',
    REMOVE_FOR_OTHERS: 'Vil du fjerne indlægget selvom det eksisterer på andre restauranter ?',
    TIMELINE_SHARED: 'Delte tidslinjen !',
    TYPE: 'Type',
    SERVING_METHOD: 'Serveringsmåde',
    APPLIES_FOR: 'Gælder for',
    PRODUCT_TYPES: 'Produkttyper',
    DISCOUNT_PERCENTAGE: 'Procent i rabat',
    AUTOMATIC_ACTIVATION: 'Aktivér automatisk for brugere',
    CREATING_OFFER: 'Opret tilbud',
    OFFER_CREATED: 'Tilbud oprettet !',
    UPDATING_OFFER: 'Opdaterer tilbuddet',
    OFFER_UPDATED: 'Tilbud opdateret',
    REMOVING: 'Fjerner',
    OFFER_REMOVED: 'Fjernet tilbuddet',
    NEW_BUTTON: 'Ny knap',
    CREATE_NEW_BUTTON: 'Opret ny knap',
    CONNECT_BUTTON: 'Hvad skal knappen knyttes til ?',
    CHOOSE_BG_IMAGE: 'Vælg baggrundsbillede…',
    BUTTON_LAYER: 'Knaplager',
    FREE_TEXT: 'Fritekst',
    ACTIVATE_IN_POS: 'AKTIVÉR PÅ KASSEN',
    ALLERGY_INFO_SAVED: 'Allergi-info gemt og kan ses i appen',
    MINIMUM_BONUS_SAVED: 'Minimum bonus er gemt',
    PAYMENT_OPTIONS_SAVED: 'Betalingsalternativ er gemt',
    DELIVERY_OPTIONS_SAVED: 'Serveringsindstillinger er gemt',
    NOTIFICATION_SAVED: 'Meddelelse gemt',
    INSTAGRAM_SAVED: 'Instagram gemt',
    FACEBOOK_SAVED: 'Facebook gemt',
    MENU_STYLE_SAVED: 'Menu layout gemt',
    FOOD_SETTINGS_SAVED: 'Mad indstillinger er gemt',
    DRINK_SETTINGS_SAVED: 'Drik indstillinger er gemt',
    DISCOUNT_SETTINGS_SAVED: 'Rabat indstillinger er gemt',
    COUPON_NAME: 'Kuponens navn',
    PERCENTAGE_IN_DISOUNT: 'Antal procent i rabat',
    TAKEAWAY: 'Takeaway',
    TABLE_SERVING: 'Bordservering',
    COLLECT_IN_BAR: 'Hent i baren',
    DELIVERY: 'Levering',
    SENDING_PUSH: 'Sender pushbeskeder',
    PUSH_SENT: 'Pushbesked sendt !',
    GENERAL: 'Generelt',
    GENERATE_REPORT: 'Generér rapport',
    PUSH_NOTIFICATIONS: 'Pushbeskeder',
    OFFERS: 'Tilbud',
    DELIVERY_OPTIONS: 'Serveringsalternativ',
    PAYMENT_OPTIONS: 'Betalingsalternativ',
    USE_SAVE_BUTTON: 'Ændringer på denne side påvirker mobilappen, og Gem-knapperne skal bruges, før ændringerne træder i kraft ',
    OPEN_FOR_SALE: 'Åben for salg',
    MESSAGE_WHEN_CLOSED: 'Meddelelse til kunden når fanen er lukket ',
    FOOD_TAB: 'Mad fane',
    DRINK_TAB: 'Drik fane',
    NOTIFICATION_IN_APP: 'Meddelelse i appen',
    SHOW_NOTIFICATION: 'Vis meddelelse',
    NOTIFICATION_TEXT: 'Tekst til meddelelse',
    ALLERGY_INFO: 'Allergi-info',
    PHONE_NUMBER: ' Telefonnummer',
    OPENING: 'Åbner klokken',
    CLOSING: 'Lukker klokken',
    SHOW_FACEBOOK: 'Vis Facebook-kort på startsiden',
    INSTAGRAM: ' Instagram',
    SHOW_INSTAGRAM: 'Vis Instagram-kort på startsiden',
    WHICH_ACTIVE: 'Hvilke skal være aktiveret i appen ?',
    SWISH: 'Swish',
    TAB: 'Bord bemærkning',
    TABLENUMBER_FROM: 'Bord nummer fra',
    TABLENUMBER_TO: 'Bord nummer til',
    AREA_1: 'Område 1',
    AREA_2: 'Område 2',
    AREA_3: 'Område 3',
    AREA_4: 'Område 4',
    DELIVERY_RADIUS: 'Leveringsradius i meter',
    DELIVERY_RADIUS_COST: 'Pris for leveringsradius',
    EDIT_LOCATIONS: 'Rediger pladser',
    MINIMUM_FEE: 'Minimumafgift',
    BONUSSYSTEM: 'Bonussystem',
    LEAST_AMOUNT_BONUS: 'Mindste antal point for at handle med point',
    GLOBAL_OFFERS: 'Globale tilbud',
    APPLIES_TO_ALL: 'Gælder for alle i appen',
    ONETIME: 'Engangs',
    USER_GROUPS: 'Brugergrupper',
    ADD_NEW: 'Opret ny',
    GROUP_NAME: 'Gruppenavn',
    DISCOUNT_CODES: 'Rabatkoder',
    DISCOUNTPERCENT: 'Rabatprocent',
    APPLY_AUTOMATICALLY: 'Anvend rabatkode automatisk for kunder i appen',
    SEND_PUSH: 'Send pushbesked',
    SEND_PUSH_TEXT: 'Meddelelse sendes øjeblikkeligt ud til alle lokale brugere',
    SEND: 'Send',
    ALTERNATIVES: 'Alternativ',
    HEADER_EX: 'Rubrik (fx grad af stegning)',
    OPTION_TYPE: 'Type af tilvalg',
    CHECKBOX: 'Afkrydsningsfelt',
    MULTIPLE: 'Flere muligheder',
    PRICE: 'Pris',
    OPTIONS: 'Tilvalg',
    COPY_FROM: 'Kopiér fra',
    USING_STEP_BY_STEP: 'Bruger trin-for-trin flow',
    HEADER: 'Rubrik',
    SUBHEADER: 'Underrubrik',
    LINK_WITH: 'Koblet med',
    EDIT_EXCEPTION: 'Skift undtagelse',
    REASON: 'Anledning',
    REASON_DETAILS: 'Anledningsdetaljer',
    ACCOUNTING: 'Kontering',
    SEARCH_PRODUCT: 'Søg produkt',
    DELIVERY_TYPES: 'Leveringmåde',
    REMOVE_EXCEPTION_CONFIRM: 'Vil du fjerne undtagelsen ?',
    REMOVE_EXCEPTION: 'Fjern undtagelse !',
    SAVE_WITHOUT_ACCOUNTING: 'Du kan ikke gemme produkter uden bogføringsoplysninger og produkttype',
    REMOVE_PRODUCT_RESTURANTS: 'Vil du fjerne produktet fra flere restauranter',
    PRODUCT_SHARED: 'Del produktet !',
    PRODUCT_INFORMATION: ' Produktinformation',
    BASIC_INFO: 'Basisinformation',
    ACTIVE: 'Aktiv',
    PRODUCT_ACTIVE: 'Produkt aktiv',
    PRICE_KR: 'Pris i',
    WEIGHT_BASED_PRODUCT: 'Vægtbaseret produkt',
    WEIGHT_BASED_HINT: 'Gæsten vælger vægten i appen. Prisen beregnes som vægt i gram / 100 × pris per 100 g.',
    WEIGHT_BASED_APP_ONLY: 'Dette produkt er kun tilgængeligt i appen. Det kan ikke vises i expresskiosk eller weborder.',
    PRICE_PER_100G: 'Pris per 100 g',
    MIN_WEIGHT_G: 'Mindste vægt (g)',
    MAX_WEIGHT_G: 'Højeste vægt (g)',
    WEIGHT_STEP_G: 'Vægttrin (g)',
    PER_100_G: '/ 100 g',
    WEIGHT_CONFIG_INVALID: 'Ugyldig vægtkonfiguration. Min skal være mindst trinnet, max skal være større end min, og (max − min) skal kunne deles med trinnet.',
    WEIGHT_BASED_INCOMPATIBLE: 'Vægtbaseret pris kan ikke kombineres med Build-a-Burger eller kombinerede produkter.',
    BONUS_CONVERT: 'Procent som konverteres til bonuspoint ved køb af produkt',
    ONUS_CONVERT_WALLET: 'Procent som konverteres til bonuspoint ved køb af mobile wallet',
    NOT_ALLOWED_TO_BY_WITH_BONUS: 'Får inte köpas för bonuspoäng',
    DESCRIPTION_SHORT: 'Beskrivelse (kort)',
    LONG_DESCRIPTION: 'Lang beskrivelse',
    DESCRIPTION_LONG: 'Beskrivelse (lang)',
    CATEGORY_BONG_INFO: 'Kategori- og bon-information',
    NAME_ON_BONG: 'Navn på bon (valgfri)',
    PRODUCT_TYPE: 'Produkttype',
    PRODUCT_CATEGORY: 'Produktkategori',
    BONG_CATEGORY: 'Bonkategori',
    ACCOUNTING_VAT: 'Bogføring og moms',
    EXCEPTION: 'Undtagelse',
    CONTAINS_ALCOHOL: 'Produktet indeholder alkohol',
    AGE_LIMIT: 'Aldersgrænse 18+',
    PURCHASE: 'Indkøb',
    COST: 'Kostpris',
    MARGIN: 'Margen',
    TAGS: 'Mærker',
    NEW_TAG: 'Nyt mærke',
    EXTERNAL_ID: 'Eksternt ID',
    STOCK_BALANCE: 'Lagersaldo',
    COUNT: 'Antal',
    ACOUNTINGS: 'Konteringer',
    VAT_RATE: 'Momssats',
    VAT_RATES: 'Momssatser',
    ACCOUNTING_ACCOUNT: 'Bogføringskonto',
    NO_ACCOUNT: 'Ingen konto',
    ACCOUNTING_CREATED: 'Kontering oprettet',
    PAYMENT_TYPES: 'Betalingsmetode',
    ACTIVATED_PAYMENT_TYPES: 'Aktiveret betalingsmetode',
    ADITIONAL_PAYMENT_TYPES: 'Flere betalingsmetoder',
    NO_PAYMENT_TYPES: 'har ingen betalingsmetoder aktiveret. Tryk på Flere betalingsmetoder for at aktivere en',
    ADDED: 'Tilføjet',
    PAYMENT_FEES: 'Der er betalingsmetoder er forbundet med gebyrer. Her vælger du konti til disse ',
    VAT: 'Moms',
    HOME: 'Hjem',
    RESTAURANT: 'Restaurant',
    MENU: 'Menu',
    REDEMPTION_AGREEMENT: 'Indløsningsaftale',
    MANAGE: 'Styre',
    REPORTS: 'Rapporter',
    ADMIN: ' Administration',
    NEWS: 'Nyhedsstrøm',
    APP: 'App',
    POS: 'KASSE',
    STAFF_CARD: 'Personalekort',
    MISC: 'Misc.',
    SETTINGS: 'Indstillinger',
    PAYMENT_METHOD: 'Betalingsmetode',
    PAYMENT_SOURCE: 'Betalingskilde',
    RESTURANT_INFO: 'Restaurantinformation',
    USERS: 'Brugere',
    SEE_ALL: 'Se alle…',
    STATISTICS: 'Statistik',
    DARK_MODE: 'Mørk tilstand',
    SELECT_UNIT: 'Vælg enhed',
    OPENING_H_SAVED: 'Åbningstider gemt',
    OPENING_H: 'Åbningstider',
    OPEN_CLOSE_AUTOMATICALLY: 'Åbn/luk app automatisk',
    AUTO_OPENING_HOURS_TITLE: 'Automatiske åbningstider',
    AUTO_OPENING_HOURS_DESCRIPTION:
        'Sæt flueben for at salgskanalerne åbner og lukker automatisk efter åbningstiderne og afvigelserne nedenfor. Uden flueben vises åbningstiderne kun som information.',
    AUTO_OPENING_HOURS_ON:
        'Aktiv – salgskanalerne åbner og lukker automatisk efter tiderne nedenfor.',
    AUTO_OPENING_HOURS_OFF:
        'Ikke aktiv – åbningstiderne vises kun som information i salgskanalerne og styrer ikke, hvornår I åbner eller lukker.',
    AUTO_OPENING_HOURS_TAG_ON: 'Styrer åbning/lukning',
    AUTO_OPENING_HOURS_TAG_OFF: 'Kun information',
    CLOSED: 'Lukket',
    OPENS: 'Åbner',
    CLOSES: 'Lukker',
    DEVIATIONS: 'Afvigelser',
    SELECT_LOGO: 'Vælg logo..',
    ORG_NO: 'CVR-nr.',
    ADRESS: 'Adresse',
    ZIP_CODE: 'Postnummer',
    POST_ADR: 'By',
    PHONE: 'Telefon',
    EMAIL: 'Email',
    ABOUT_US: 'Om os',
    ADD_USER: 'Tilføj brugere',
    ADD_DOMAIN_AUTO: 'Tilføj brugerdomæner, der automatisk føjes til denne brugergruppe ved registrering ',
    DOMAIN_EXAMPLE: '(fx kun foodandco.dk og ikke @foodandco.dk',
    LOAD: 'Lad',
    SELECT_BONG_CATEGORY: 'Vælg Bong',
    SELECT_PRODUCT_CATEGORY: 'Vælg produkt',
    SELECT_TYPE: 'Vælg Type',
    SELECT_DATE_TIME: 'Vælg dato og tid',
    OVERVIEW: 'Oversigt',
    NEW_ORDER: 'Ny ordre',
    PERSONAL_BANK_DETAILS: 'Personlige og bankoplysninger',
    CART_ITEMS: 'Indkøbskurv varer',
    LATEST_ORDERS: 'Seneste bestillinger',
    LOGO_AND_IMAGES: 'Logotyper og billeder',
    FONTS: 'Skrifttyper',
    DANGER: 'Fare',
    SUCCESS: 'Succes',
    SECONDARY: 'Sekundær',
    BASE: 'Grundlag',
    PRIMARY: 'Primær',
    COLORS: 'Farver',
    ENVIRONMENT_IMAGES: 'Klik her for at ændre logo, miljøbilleder',
    HIDE_ADVANCE_SETTINGS: 'Skjul avancerede indstillinger',
    SHOW_ADVANCE_SETTINGS: 'Vis forhåndsindstillinger',
    NEW_THEME: 'Nyt tema',
    THEME_MAIN_TEXT: 'Skift skrifttyper og farver til din butiksfacade',
    THEMING: 'Temaer',
    CHOOSE: 'Vælg ...',
    LINK_TO_PRODUCT: 'Link til produkt eller hjemmeside',
    START_WITH_HTTPS: 'skal starte med https: //',
    WHERE_IS_PRODUCT: 'Hvor er produktet?',
    OFFER_INFO_PLACEHODLER: 'Informationstekst for tilbuddet ...',
    OPTION_DESCRIPTION: 'Beskrivelse af tilbuddet',
    SELECT: 'Vælg',
    DISCOUNT_PERCENTAGE_PLACEHOLDER: 'Antal procent, brugeren får i rabat',
    WRITE: 'Skriv...',
    SEARCH_PRODUCT_OR_TAG: 'Søg produkt eller tag',
    STEP_PLACEHOLDER: 'Trin til at opbygge dit højre flow',
    ABOUT_US_PLACEHOLDER: 'Om oss',
    DOMAIN_EX: 'Domæne f.eks. Pubq.se',
    TIME_CONTROL_MENU: 'Timer menuen',
    SET: 'Indstill',
    SCHEDULE: 'Skema',
    ACTIVATION_TIME: 'Aktiveringstid',
    ACTIVATE_MENU: 'Aktiver menu',
    WEEK: 'Uge',
    SELECT_Z_REPORT: 'Vælg Z-rapporter',
    FROM_TO: 'Fra - Til',
    SEND_END_TO_FORTNOX: 'Sende denne dagsafslutning til Fortnox ?',
    IMPORT_SUCCESSFUL: 'Import gennemført',
    IMPORT_FAILED: 'Import fejlede',
    WHICH_EMAIL: 'Hvilken mailadresse skal filen sendes til ?',
    SUMD_Z_REPORTS: 'Samlet Z-rapporter',
    Z_REPORT: 'Z-rapporter',
    MAIL: 'Mail',
    PREVIOUS_MONTH: 'Foregående måned',
    COMPILATION: 'Sammenfatning',
    JOURNALNR: 'Journal nr.',
    CREATED: 'Oprettet',
    RECEIPTNO_FROM_TO: 'Kvittering fra - til',
    SUM: 'Sum',
    INTEGRATIONS_HEADER: 'Integrationer',
    BUY_REBUY: 'Køb og genkøb',
    WRONG_HIT: 'Forkert indtastning',
    CANCELD: 'Afbrudt',
    PROFORMA: 'Proforma',
    CREATING_ENDOFDAY: 'Opretter dagsafslutning',
    NOT_ENOUGH: 'Du har ikke omsat tilstrækkeligt',
    END_OF_DAY_100: 'Dagsafslutning skal indeholde mere end 100',
    Z_ENDOFDAY: 'Z-dagsafslutning',
    PREL_X_REPORT: 'Foreløbig X-rapport',
    PAID: 'Betalt',
    SUM_PAYMENTS: 'Summen af alle betalingsmåder',
    CHANGE_IN: 'Byttepenge IND',
    CHANGE_OUT: 'Byttepenge UD',
    ACCOUNTING_REPORTS: 'Bogføringsrapport til regnskab',
    STARTED: 'Startet',
    FINISHED: 'Afsluttet',
    ACCOUNTS: 'Konti',
    ROWS: 'Rækker',
    SALES: 'Salg',
    PAYMENTS: 'Betalingsmåde',
    RECEIPTS: 'Kvittering',
    ACCOUNTING_ACCOUNTS: 'Bogføringskonti',
    TODAY: 'I dag',
    YESTERDAY: 'I går',
    LAST_WEEK: 'Sidste uge',
    THIS_MONTH: 'Denne måned',
    LAST_MONTH: 'Sidste måned',
    USER: 'Bruger',
    ORDERS: 'Ordrer',
    END_OF_DAY: 'End of day',
    HISTORY: 'Historie',
    TIP_REPORT: 'Rapport over tip',
    DESC_GENERATE_REPORT: 'Rapporten genereres til en PDF-fil, der automatisk hentes.',
    GENERATING_REPORT: 'Genererer rapporten',
    ERROR_TIP_REPORT: 'Noget gik galt i generationen af tip-rapporten!',
    COMPANY_NAME: 'Firmanavn',
    EMAIL_NOT_VALID: "E-postadressen er ikke gyldig",

    //Banking info traslation
    BANKINFO_HEADER: 'Personlige og bankoplysninger',
    BANKINFO_SUB_HEADER: 'Udfyld skemaet',
    BANKINFO_FIRST_NAME: 'Fornavn',
    BANKINFO_LAST_NAME: 'Efternavn',
    BANKINFO_BUSINESS_NAME: 'Virksomhedens navn',
    BANKINFO_PHONE_NUMBER: 'Telefonnummer til CEO',
    BANKINFO_EMAIL: 'E-mail til CEO',
    BANKINFO_TAX_ID: 'Skatte ID',
    BANKINFO_LIST_OF_OWNERS: 'Liste over ejere',
    BANKINFO_UPLOAD_IDENTIFCATION: 'Upload identifikation',
    BANKINFO_ADD_OWNER: 'Tilføj ejere',
    BANKINFO_BANK_NAME: 'Bank-navn',
    BANKINFO_BANK_ACCOUNT_NUMBER: 'Bankkontonummer',
    BANKINFO_BANK_PROOF: 'Upload bankskærmbillede',
    BANKINFO_SEND_VERIFICTION: 'Send til verifikation',
    MIN_LENGTH: 'min længde',
    ZERO_NOTIFICATION: "Ingen nye meddelelser",
    //************************************* Pdf translation ***********************
    PDF_HEADER: 'Pdf visning',
    PDF_DOWNLOAD: 'Download pdf',
    PDF_FORMAT: 'Vælg Sidestørrelse',
    PDF_TEXT: 'Indtast tekst',
    PDF_TEXT_COLOR: 'Tekst farve',
    PDF_BACKGROUND_COLOR: 'Baggrundsfarve',
    GRIN_HEADER: 'Returboks',
    GRIN_PACKAGES: 'Boks',
    GRIN_NONE: 'Ingen',
    EMPLOYEE_ID: 'Medarbejder-ID',
    TAG_ID: 'Tag-ID',
    ENTER_EMPLOYEE_ID: 'Indtast medarbejder-ID',
    ENTER_TAG_ID: 'Indtast tag-ID',
    MANUAL_ENTRY: 'Manuel indtastning',
    MANUAL_EMPLOYEE_ID: 'Medarbejder-ID',
    MANUAL_TAG_ID: 'Tag-ID',
    ENTER_MANUAL_EMPLOYEE_ID: 'Indtast medarbejder-ID',
    ENTER_MANUAL_TAG_ID: 'Indtast tag-ID',
    ADD_MANUAL_USER: 'Tilføj manuel bruger',
    COMPLETED: "Færdig",
    ENABLED: 'Aktiveret',
    DISABLED: 'Deaktiveret',
    SETTINGS_UPDATED: "Indstillinger opdateret.",
    SETTINGS_COULDNT_UPDATE: "Noget gik galt. Kunne ikke opdatere indstillinger.",
    CATERING_CUTOFF_TIME_UPDATED: "Bestillingsfristen er opdateret",
    CATERING_CUTOFF_TIME_COULDNT_UPDATE: "Noget gik galt. Kunne ikke opdatere bestillingsfristen.",
    ALLERGEN_DESCRIPTION: 'Allergen Beskrivelse',
    AUTO_APPROVE_ORDERS_HEADER: 'Godkend bestillinger automatisk',
    AUTO_APPROVE_ORDERS_DESCRIPTION: 'Godkend indgående cateringbestillinger automatisk uden manuel gennemgang.',
    SHOW_MANDATORY_POPUP_FOR_DATE_HEADER: 'Obligatorisk popup for datovalg',
    SHOW_MANDATORY_POPUP_FOR_DATE_DESCRIPTION: 'Vis en popup i catering-webappen, der kræver, at kunden vælger en dato, før menuen vises.',
    NOTIFICATION_EMAILS_HEADER: 'E-mailnotifikationer for bestillinger',
    NOTIFICATION_EMAILS_DESCRIPTION: 'Tilføj e-mailadresser for at modtage notifikationer om nye cateringbestillinger. Flere e-mailadresser kan tilføjes.',
    NOTIFICATION_EMAIL_LANGUAGE: 'Sprog for notifikationsmail',
    ADD_EMAIL: 'Tilføj e-mail',
    ENTER_EMAIL_ADDRESS: 'Indtast e-mailadresse',
    ADDED_EMAILS: 'Tilføjede e-mailadresser',
    NO_EMAILS_ADDED: 'Ingen e-mailadresser tilføjet',
    INVALID_EMAIL_FORMAT: 'Ugyldigt e-mailformat',
    EMAIL_ALREADY_EXISTS: 'E-mailadressen findes allerede',
    START_TIME_MUST_BE_LESS_THAN_END_TIME: "Starttid skal være mindre end sluttid",
    START_AND_END_TIME_CANNOT_BE_SAME: "Starttid og sluttid kan ikke være det samme",
    TIME_SLOT_OVERLAPS_WITH_ANOTHER: "Denne tidslukke overlapper med en anden tidslukke",
    START_DATE_REQUIRED: "Startdato kræves for at tilføje afhentnings-/leveringsdatoer",
    DATE_ALREADY_EXISTS: "Denne dato er allerede tilføjet. Vælg en anden dato.",
    END_DATE_AFTER_START_DATE: "Slutdato skal være efter startdato",
    BOTH_DATES_PASSED_WARNING: "Både start- og slutdato er passeret. Opdater datoerne, før du aktiverer denne menu.",
    PAST_DATE_RANGE_EDIT_WARNING: "Både start- og slutdato ligger i fortiden. Opdater slutdatoen til i dag eller senere for at redigere startdatoen.",
    PAST_SCHEDULE_DATES_WARNING: "En eller flere afhentnings-/leveringsdatoer ligger i fortiden. Opdater eller fjern gamle datoer for at gemme ændringer.",
    CATERING_PRODUCTION_DAYS_HEADER: 'Produktionsdage',
    CATERING_PRODUCTION_DAYS_DESCRIPTION: 'Konfigurer hvilke ugedage der tæller som produktionsdage ved beregning af minimum afhentningsdato. Dage der ikke er produktionsdage vil blive sprunget over ved tælling af ledetid.',
    CATERING_PRODUCTION_DAYS_LABEL: 'Dage der tæller som produktionsdage',
    CATERING_MENU_PREFERENCE_HEADER: 'Produktmenutype',
    CATERING_MENU_PREFERENCE_DESCRIPTION: 'Vælg hvilken menutype der skal vise et produkt, hvis det findes i både Normal og Kampagnemenuer. Når et produkt tilføjes til begge menutyper, vises det kun i den menutype, der vælges her i indstillingerne.',
    IMPORTANT: 'Vigtigt',
    MENU_PREFERENCE_NOTE: 'Et produkt kan kun tilhøre én menutype. Hvis det optræder i både Kampagne- og Normalmenuer, vises det i henhold til din valgte menupreference.',
    CATERING_SELECT_MENU_TYPE: 'Vælg menutype',
    CATERING_MENU_PREFERENCE_NOTE: 'Hvis et produkt tilføjes til begge menutyper, vises det kun i den foretrukne menutype.',
    CATERING_CAMPAIGN_MENU: 'Kampagne',
    CATERING_REGULAR_MENU: 'Normal',
    COMMENT_ENABLED: 'Kommentar aktiveret',
    DEVIATION_INCOMPLETE: 'Anledning, startdato og slutdato er påkrævet',
    DEVIATION_START_DATE_IN_PAST: 'Startdato kan ikke være før i dag',
    DEVIATION_END_DATE_IN_PAST: 'Slutdato kan ikke være før i dag',
    OVERLAPPING_DEVIATION_DATE_RANGE: 'Dette datointerval overlapper med en anden afvigelse',
    OVERLAPPING_TIME_SLOT:'Overlapper med eksisterende tidsrum',
    END_TIME_BEFORE_START_TIME:'Sluttid skal være efter starttid',
    KIOSK_INFORMATION: 'Kiosk-pladser',
    ORDER_LIST_APP_HINT: 'Træk for at ændre visningsrækkefølge i appen. Klik på Gem ovenfor for at anvende.',
    ORDER_LIST_KIOSK_HINT: 'Træk for at ændre visningsrækkefølge for kiosk-pladser. Klik på Gem ovenfor for at anvende.',
    YES_DELETE: 'Ja, slet',
    TABLE_QR_CODE: 'Bordets QR-kode',
    TABLE_DETAILS: 'Borddetaljer',
    TABLE_MANAGMENT: 'Bordstyring',
    TABLE_MANAGMENT_DESCRIPTION: 'Administrer bordgrupper. Hver gruppe definerer et interval af borde (f.eks. 70–100). Bordene genereres dynamisk — intet gemmes individuelt.',
    SERVING_METHOD_NAME: 'Navn på serveringsmetode',
    SERVING_METHOD_NAME_DESC: 'Konfigurer hvordan denne serveringsmetode skal vises i salgskanalerne.',
    TABLE_SERVING_OPTION: 'Bordservering',
    SEAT_SERVING_OPTION: 'Pladsservering',
    TABLE_SERVING_DESCRIPTION: 'Tillad gæster at bestille direkte til bordet',
    SEAT_SERVING_DESCRIPTION: 'Tillad gæster at bestille direkte til pladsen',
    TABLE: 'Bord',
    NEW_GROUP: 'Ny gruppe',
    DOWNLOAD_ALL_QR: 'Download alle QR-koder',
    UNIT_NAME: 'Enhedsnavn',
    WEB_ORDER_BASE_URL: 'Webordre basis-URL',
    CREATE_TABLE_GROUP: 'Opret bordgruppe',
    EDIT_TABLE_GROUP:'Rediger bordgruppe',
    CREATE_SEAT_GROUP: 'Opret pladsgruppe',
    EDIT_SEAT_GROUP: 'Rediger pladsgruppe',
    TABLE_RANGE: 'Bordinterval',
    SEAT_RANGE: 'Pladsinterval',
    TABLES_WILL_GENERATE:'Dette vil generere {count} borde',
    SEATS_WILL_GENERATE: 'Dette vil generere {count} pladser',
    END_MUST_BE_GREATER_EQUAL_START:'Slut skal være ≥ Start',
    SELECT_ALL: 'Vælg alle',
    DOWNLOAD_RANGE: 'Download interval',
    QR_CODE:'QR kode',
    FORMAT: 'Format',
    DOWNLOAD_AS: 'Download som',
    TABLES: 'Borde',
    SEATS: 'Pladser',
    SEAT: 'Plads',
    SEAT_GROUPS: 'Pladsgrupper',
    SEAT_MANAGEMENT_DESCRIPTION: 'Administrer pladsgrupper. Hver gruppe definerer et interval af pladser (f.eks. 70–100). Pladser genereres dynamisk – intet gemmes individuelt.',
    VIEW_TABLES: 'Vis borde',
    VIEW_SEATS: 'Vis pladser',
    NO_TABLE_GROUPS_YET: 'Ingen bordgrupper endnu',
    NO_SEAT_GROUPS_YET: 'Ingen pladsgrupper endnu',
    GROUP_NAME_REQUIRED: 'Gruppenavn er påkrævet',
    UNIT_NAME_REQUIRED: 'Enhedsnavn er påkrævet',
    WEB_ORDER_URL_REQUIRED: 'Webordre-URL er påkrævet',
    SEO_SETTINGS: 'SEO-indstillinger',
    SEO_SETTINGS_DESC: 'Konfigurer søgemaskineoptimeringsmetadata for at forbedre synligheden på Google.',
    SEO_TITLE: 'SEO-titel',
    SEO_TITLE_NOTE: 'Titel vist i Google søgeresultater og fanebladet i browseren. Efterlad tom for at bruge standardtitel.',
    SEO_DESCRIPTION: 'SEO-beskrivelse (Metabeskrivelse)',
    SEO_DESCRIPTION_NOTE: 'Kort oversigt vist under titlen i Google søgeresultater. Anbefalet længde: 120-160 tegn.',
    TABLE_RANGE_REQUIRED: 'Bordinterval er påkrævet',
    SEAT_RANGE_REQUIRED: 'Pladsinterval er påkrævet',
    START_MUST_BE_LESS_EQUAL_END: 'Start skal være ≤ Slut',
    MAX_1000_TABLES_ALLOWED: 'Intervallet må ikke overstige 1000 borde pr. gruppe',
    MAX_1000_SEATS_ALLOWED: 'Intervallet må ikke overstige 1000 pladser pr. gruppe',
    DELETE_GROUP: 'Slet gruppe',
    DELETE_GROUP_CONFIRM: 'Slet "{group}" ({tables} {start}–{end})? Dette kan ikke fortrydes.',
    GROUP_DELETED: 'Gruppen blev slettet',
    FAILED_DELETE_GROUP: 'Kunne ikke slette gruppen',
    SEARCH_GROUPS: 'Søk grupper...',
    DOWNLOADED:'Downloadet',
    DOWNLOADING_QR_CODES:'Downloader QR-koder...',
    STAMP_CARD_DELIVERY_METHODS: 'Leveringsmetoder',
    STAMP_CARD_DELIVERY_METHODS_HINT: 'Alle metoder er tilladt som standard; fjern markering for at begrænse hvilke leveringsmetoder der skal gælde.',
    STAMP_CARD_DM_EAT_IN: 'Spis her',
    STAMP_CARD_DM_TAKEAWAY: 'Takeaway',
    STAMP_CARD_DM_DELIVER_TO_WORKPLACE: 'Lever til arbejdsplads',
    STAMP_CARD_DM_DELIVERY: 'Levering',
    STAMP_CARD_DM_TABLE_SERVING: 'Bordservering',
    SALES_CHANNELS: 'Salgskanaler',
    CHANNEL_APP: 'App',
    CHANNEL_KIOSK: 'Kiosk',
    CHANNEL_POS: 'POS',
    CHANNEL_WEB: 'Web',
    CUSTOMER_VISIBILITY: 'Kundesynlighed',
    ALL_CUSTOMERS: 'Alle kunder',
    LOGGED_IN_USERS_ONLY: 'Kun loggede brugere',
    ADDON_SERVING_METHODS: 'Serveringsmetoder',
    ADDON_SERVING_METHODS_HINT: 'Alle serveringsmetoder er aktiveret som standard. Fjern markering for at skjule dette tilvalg for en metode.',
    NEXT: 'Næste',
    ADDONS_V2_RULES_SECTION: 'Valgregler',
    ADDON_WIZARD_RULES: 'Regler',
    ADDON_LABEL_SELECTION_TYPE: 'Valgtype',
    ADDON_LABEL_PRESELECT_MODE: 'Forvalgt tilstand',
    ADDON_LABEL_MIN_SELECTIONS: 'Min. antal valg',
    ADDON_LABEL_MAX_SELECTIONS: 'Maks. antal valg',
    ADDON_REQUIRED_BEFORE_PROCEED: 'Påkrævet før gæsten kan fortsætte',
    ADDON_LABEL_PRESELECTED_OPTION: 'Forvalgt mulighed',
    SHOW_WHEN_RULES: 'Hvornår vises det',
    SHOW_WHEN_HINT: 'Denne gruppe vises kun, når specifikke betingelser er opfyldt fra en anden gruppes valg.',
    ACTIVE_DEPENDENCIES: 'Aktive afhængigheder',
    DEPENDS_ON_GROUP: 'Afhænger af gruppe',
    OPTIONS_TO_TRIGGER: 'Muligheder der udløser',
    ADD_DEPENDENCY: 'Tilføj afhængighed',
    SHOW_WHEN_GROUP_PREFIX: 'Vis når gruppen',
    SHOW_WHEN_INCLUDES_VERB: 'indeholder',
    ADDON_VALIDATE_INVALID_PAYLOAD: 'Ugyldige tilvalsregler',
    ADDON_VALIDATE_MAX_SELECTIONS_RADIO: 'Grupper med ét valg skal have maks. antal valg = 1',
    ADDON_VALIDATE_PRESELECT_SPECIFIC: 'Vælg en forvalgt mulighed eller skift forvalgt tilstand',
    ADDON_VALIDATE_MAX_LT_MIN: 'Maks. antal valg kan ikke være mindre end min.',
    ADDON_SELECT_ONE_RADIO: 'Et valg (radio)',
    ADDON_SELECT_MULTIPLE_CHECKBOX: 'Flere valg (afkrydsning)',
    ADDON_PRESELECT_NONE: 'Ingen',
    ADDON_PRESELECT_FIRST: 'Første mulighed',
    ADDON_PRESELECT_SPECIFIC: 'Bestemt mulighed',
    SUBTITLE_LABEL: 'Undertitel',
    ALWAYS_VISIBLE: 'Altid synlig',
    VISIBLE_IN_DELIVERY_MENU: 'Synlig i leveringsmenu',
    VISIBLE_IN_TAKEAWAY_MENU: 'Synlig i takeaway-menu',
    VISIBLE_IN_EATIN_MENU: 'Synlig i spis-her-menu',
    VISIBLE_IN_TABLEORDER_MENU: 'Synlig i bordbestillingsmenu',
    VISIBLE_IN_DELIVERYSETLOCATION_MENU: 'Synlig i fast leveringsstedsmenu',
    COMMENT_FIELD_ON_ORDER: 'Kommentarfelt på bestilling',
    COMMENT_FIELD_DESCRIPTION: 'Aktiver eller deaktiver kommentarfeltet i checkout.',
    CAROUSEL: 'Samlinger',
    SLIDE_PLAYBACK_FAILED: 'Afspilning mislykkedes',
    MENU_DISPLAY: 'Menydisplay',
    // Signage (menu display)
    MENUDISPLAY_MENU_DISPLAY_CONFIG_SUBTITLE: 'Konfigurer logo, baggrund, skriftfarve og synlighed for produktbillede.',
    MENUDISPLAY_TOGGLE_ON: 'Til',
    MENUDISPLAY_TOGGLE_OFF: 'Fra',
    MENUDISPLAY_FONT_COLOR_HEX_PLACEHOLDER: '#000000',
    MENUDISPLAY_FONT_FAMILY_TITLE: 'Skrifttype',
    MENUDISPLAY_FONT_FAMILY_SUBTITLE: 'Vælg en Google Font til menutekst på skærmen.',
    MENUDISPLAY_FONT_PREVIEW_SAMPLE: 'Eksempel: Aa Bb Cc 0123456789',
    MENUDISPLAY_LOGO_TITLE: 'Logo',
    CHANGE_LOGO: 'Skift logo',
    MENUDISPLAY_UPLOADED: 'Uploadet',
    MENUDISPLAY_NOT_SET: 'Ikke angivet',
    MENUDISPLAY_LOGO_PREVIEW_ALT: 'Logo preview',
    MENUDISPLAY_REPLACE_IMAGE: 'Udskift billede',
    MENUDISPLAY_CLICK_TO_UPLOAD_LOGO: 'Klik for at uploade',
    MENUDISPLAY_LOGO_UPLOAD_HINT: 'PNG, JPG, SVG · Anbefalet 400×400px',
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_TITLE: 'Tilpasset menydisplay',
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_SUBTITLE: 'Opret og administrer genanvendelige produktgrupper til skilteslides.',
    CUSTOM_MENU_DISPLAY_SAVE_SUCCESS: '"{name}" er blevet gemt.',
    CUSTOM_MENU_DISPLAY_SAVE_ERROR: 'Den tilpassede visning kunne ikke gemmes. Prøv igen.',
    MENUDISPLAY_BACKGROUND_PREVIEW_ALT: 'Baggrundspreview',
    MENUDISPLAY_CLICK_TO_UPLOAD_BACKGROUND: 'Klik for at uploade baggrund',
    MENUDISPLAY_BACKGROUND_UPLOAD_HINT: 'PNG, JPG · Anbefalet 1920×1080px',
    MENUDISPLAY_CHANGE_IMAGE: 'Skift billede',
    MENUDISPLAY_UNSAVED_CHANGES_HINT: 'Du har ikke-gemte ændringer',
    MENUDISPLAY_LOADING_ARIA_LABEL: 'indlæser',
    MENUDISPLAY_LOADING_THEME_SETTINGS_TEXT: 'Indlæser tematilpasninger…',
    // Signage (carousel)
    SLIDE_IMAGE_ALT: 'slide-billede',
    SLIDE_DELAY_SECONDS_SUFFIX: 'sek',
    SLIDE_CREATE_SUBTITLE: 'Tilføj en ny slide til din skiltning',
    SLIDE_EDIT_SUBTITLE: 'Opdater denne slide i din skiltning',
    SLIDE_DELAY_SECONDS: 'Forsinkelse i sekunder',
    SLIDE_DELAY_HINT: 'Hvor længe denne slide skal vises',
    SLIDE_VIDEO_TYPE: 'Video',
    SLIDE_VIDEO: 'Slide video',
    SLIDE_VIDEO_FILE: 'Videofil',
    SLIDE_VIDEO_ALT: 'slide video',
    SLIDE_FILE_UPLOADED: 'Fil uploadet',
    SLIDE_VIDEO_FORMATS_HINT: 'Understøttede formater: MP4. Maks. størrelse: 50 MB.',
    SLIDE_VIDEO_DURATION_HINT: 'Registreret fra den uploadede videofil',
    UPLOAD_VIDEO: 'Upload video',
    VIDEO_GALLERY: 'Video galleri',
    VIDEO_URL: 'Video URL',
    VIDEO_DURATION: 'Varighed (sekunder)',
    VIDEO_SLIDE: 'Video slide',
    VIDEO_TOO_LARGE: 'Videofil må være højst 50MB',
    VIDEO_TOO_LONG: 'Video må være højst 60 sekunder',
    VIDEO_INVALID_FORMAT: 'Kun MP4-filer understøttes',
    VIDEO_PROBE_FAILED: 'Kan ikke læse videometadata',
    VIDEO_UPLOAD_FAILED: 'Video upload mislykkedes',
    SIGNAGE_MIN_3_CHARACTERS: 'Mindst 3 tegn',
    COLLECTION_CREATED_SUCCESS: 'Samlingen blev oprettet',
    COLLECTION_UPDATED_SUCCESS: 'Samlingen blev opdateret',
    CURRENT_WEEK: 'Aktuel uge',
    NEXT_WEEK: 'Næste uge',
    ROLLOVER_SETTINGS: 'Rollover-indstillinger',
    ROLLOVER_DESCRIPTION: 'Styr hvornår bestillingsappen skal tilbyde næste uge til forudbestillinger.',
    ROLLOVER_ENABLED: 'Automatisk ugeskift',
    ROLLOVER_ENABLED_HINT: 'Når aktiveret skiftes næste uge til aktuel på den valgte dag/tid.',
    ROLLOVER_CUTOFF_DAY: 'Skiftedag',
    ROLLOVER_CUTOFF_TIME: 'Skiftetid',
    ROLLOVER_NOW: 'Skift uge nu',
    ROLLOVER_CONFIRM_MESSAGE: 'Dette flytter næste uge til aktuel uge. Næste uge beholdes som den er — brug "Nulstil næste uge" hvis du vil tømme den. Fortsæt?',
    ROLLOVER_PERFORMED: 'Ugeskift udført',
    ROLLOVER_FAILED: 'Ugeskift mislykkedes',
    ROLLOVER_SETTINGS_SAVED: 'Ugeskift-indstillinger gemt',
    NEXT_ROLLOVER_IN: 'Kunder kan bestille til næste uge fra',
    MANUAL_ACTIONS: 'Manuelle handlinger',
    MANUAL_ROLLOVER_DESCRIPTION: 'Uger gemmes efter ugenummer, så der er ikke et dataskift at køre. Brug disse handlinger til at udfylde eller rydde næste uge manuelt.',
    CLONE_CURRENT_TO_NEXT: 'Kopier aktuel til næste',
    CLONE_CURRENT_TO_NEXT_CONFIRM: 'Dette overskriver næste uge med en kopi af aktuel uge. Fortsæt?',
    CLONE_CURRENT_TO_NEXT_DONE: 'Aktuel uge kopieret til næste',
    CLONE_CURRENT_TO_NEXT_FAILED: 'Kunne ikke kopiere aktuel til næste',
    RESET_NEXT_WEEK: 'Nulstil næste uge',
    RESET_NEXT_WEEK_CONFIRM: 'Dette rydder næste uge tilbage til en tom skabelon (ingen produkter, weekender lukkede). Fortsæt?',
    RESET_NEXT_WEEK_DONE: 'Næste uge nulstillet til tom skabelon',
    RESET_NEXT_WEEK_FAILED: 'Kunne ikke nulstille næste uge',
    REMOVE_ORPHAN_WEEKLY_MENUS: 'Fjern {{count}} gamle uge-menuuger',
    REMOVE_ALL_PAST_WEEKS_CONFIRM: 'Fjerne {{count}} tidligere uge(r) fra Firebase? Aktuel og næste uge beholdes. Dette kan ikke fortrydes.',
    REMOVE_ALL_PAST_WEEKS_DONE: 'Fjernede {{count}} tidligere uge(r)',
    REMOVE_ALL_PAST_WEEKS_FAILED: 'Kunne ikke fjerne tidligere uger',
    TIME_SETTINGS: 'Tidsindstillinger',
    NO_PRODUCTS_YET: 'Ingen produkter endnu',
    ALL_PRODUCTS_ALREADY_ADDED: 'Alle produkter er allerede tilføjet',
    NO_WEEKLY_MENU_PRODUCTS_ENABLED: 'Ingen produkter er aktiveret til ugemenu. Aktivér produkter under produktets avancerede indstillinger for at tilføje dem til din ugemenu.',
    ENABLE_MORE_PRODUCTS_HINT: 'For at tilføje flere produkter, aktivér dem under Produkt > Avancerede indstillinger.',
    ADD_PRODUCTS: 'Tilføj produkter',
    ADD_MORE_PRODUCTS: 'Tilføj flere produkter',
    SELECTED_PRODUCTS: 'Valgte produkter',
    NO_PRODUCTS_SELECTED_FOR_DAY: 'Ingen produkter er tilføjet til denne dag endnu',
    SCHEDULED_TAG: 'Planlagt',
    ACTIVE_TAG: 'Aktiv',
    TODAY_LABEL: 'I dag',
    ALL_DAYS: 'Alle dage',
    DAYS_SELECTED_LABEL: '{0} dage valgt',
    ALL_WEEKS_LABEL: 'Alle uger',
    CURRENT_WEEK_LABEL: 'Aktuel uge',
    UPCOMING_WEEK_LABEL: 'Kommende uge',
    WEEK_SCOPE_PLACEHOLDER: 'Uge',
    DAYS_LABEL: 'Dage',
    WEEKLY_TIMELINE_HEADER: 'Ugetidslinje',
    WEEKLY_SCOPED_READONLY_BANNER: 'Denne ugentlige ordre kan kun fuldføres på den planlagte dag.',
    WEEKLY_SCOPED_START_PREPARING_BTN: 'Start forberedelse',
    WEEKLY_SCOPED_STARTED_SUCCESS_SUMMARY: 'Forberedelse startet',
    WEEKLY_SCOPED_STARTED_SUCCESS_DETAIL: 'Uge-scopet ordre er nu i gang.',
    WEEKLY_SCOPED_MISSING_ETA_SUMMARY: 'Ingen sluttid for denne dag',
    WEEKLY_SCOPED_MISSING_ETA_DETAIL: 'Indstil en timer, når du starter forberedelse, hvis du vil se nedtælling her.',
    WEEKLY_SCOPED_PENDING_SELECTION_HINT: 'Start forberedelse for at låse valg af linjer op for denne dag.',
    SC_USERS_CARD_RECORDS: 'Kortposter',
    SC_USERS_READY_TO_REDEEM: 'Klar til indløsning',
    SC_USERS_AVG_STAMPS: 'Gns. stempler pr. kort',
    SC_USERS_SEARCH_PLACEHOLDER: 'Søg på navn, bruger-ID eller kort...',
    SC_USERS_NO_RECORDS: 'Ingen brugerposter fundet.',
    SC_DEACTIVATED_BY_ADMIN: 'Deaktiveret af admin',
    SC_DEACTIVATED: 'Deaktiveret',
    SC_CARD_ACTIVE: 'Kort aktivt',
    SC_CARD_INACTIVE: 'Kort inaktivt',
    SC_USER_DEACTIVATED: 'Bruger deaktiveret',
    SC_USER_ACTIVE: 'Bruger aktiv',
    SC_DEACTIVATED_BANNER: 'Dette kort er deaktiveret for denne bruger — stempler bevares, men indløsning er blokeret indtil det genaktiveres.',
    SC_STAMP_PROGRESS: 'Stempel fremskridt',
    SC_LAST_STAMP: 'Seneste stempel',
    SC_LAST_REDEEMED: 'Sidst indløst',
    SC_LAST_USED_DATE: 'Dato for seneste aktivitet',
    SC_CARD_NAME: 'Kortnavn',
    SC_CARD_ID: 'Kort-ID',
    SC_ADD_STAMP: 'Tilføj stempel',
    SC_REMOVE_STAMP: 'Fjern stempel',
    SC_NO_STAMPS_TO_REMOVE: 'Ingen stempler at fjerne',
    SC_MAX_STAMPS_REACHED: 'Maks stempler nået – marker som indløst',
    SC_NOT_READY_TO_REDEEM: 'Kortet er endnu ikke klar til indløsning',
    SC_MARK_REDEEMED: 'Marker som indløst',
    SC_DEACTIVATE: 'Deaktiver',
    SC_REACTIVATE: 'Genaktiver',
    SC_LOADING_HISTORY: 'Indlæser historik…',
    SC_NO_HISTORY: 'Ingen aktivitet registreret endnu.',
    SC_LOG_STAMP_ADDED: 'Stempel indsamlet',
    SC_LOG_REDEEMED: 'Indløst',
    SC_LOG_ADMIN_STAMP_ADDED: 'Admin: Stempel tilføjet',
    SC_LOG_ADMIN_STAMP_REMOVED: 'Admin: Stempel fjernet',
    SC_LOG_ADMIN_REDEEMED: 'Admin: Markeret som indløst',
    SC_LOG_ADMIN_DEACTIVATED: 'Admin: Kort deaktiveret',
    SC_LOG_ADMIN_REACTIVATED: 'Admin: Kort genaktiveret',
    SC_STAMP: 'stempel',
    SC_STAMPS: 'stempler',
    SC_REFRESH: 'Opdater',
    SC_USER_COL: 'Bruger',
    SC_STAMP_CARD_COL: 'Stempelkort',
    SC_STAMPS_COL: 'Stempler',
    SC_PROGRESS_COL: 'Fremskridt',
    SC_NOT_READY: 'Ikke klar',
    SC_ALL_CARDS: 'Alle kort',
    SC_STAMP_CARD_DETAILS: 'Stempelkortdetaljer',
    SC_FAILED_LOAD_PROGRESS: 'Kunne ikke indlæse brugerfremskridt',
    CATERING_COMMUNICATION_TAB: 'Kommunikation',
    CATERING_THEME_TAB: 'Tema',
    CATERING_HERO_IMAGE_AND_LOGO_HEADER: 'Hero-billede og logo',
    CATERING_HERO_IMAGE_AND_LOGO_DESCRIPTION: 'Konfigurer hero-billede og logo.',
    CATERING_BUTTON_COLORS_HEADER: 'Knapfarver',
    CATERING_BUTTON_COLORS_DESCRIPTION: 'Tilpas den primære knapfarve og knaptekstfarve, der bruges i Catering-webappen.',
    CATERING_BUTTON_PRIMARY_COLOR: 'Primær knapfarve',
    CATERING_BUTTON_TEXT_COLOR: 'Knaptekstfarve',
    CATERING_FONTS_HEADER: 'Tema-skrifttyper',
    CATERING_FONTS_DESCRIPTION: 'Konfigurer titel- og brødtekstskrifttyper.',
    CATERING_TITLE_FONT_LABEL: 'Titelskrifttype',
    CATERING_BODY_FONT_LABEL: 'Brødtekstskrifttype',
    CATERING_THEME_LOGO_HEADER: 'Logo',
    CATERING_THEME_HERO_IMAGE_HEADER: 'Hero-billede',
    CATERING_THEME_PREVIEW_HEADER: 'Forhåndsvisning',
    CATERING_THEME_PREVIEW_BTN_SOLID: 'Knap',
    CATERING_THEME_PREVIEW_BTN_OUTLINED: 'Omrids',
    CATERING_THEME_PREVIEW_BTN_TEXT: 'Tekst',
    CATERING_THEME_REPLACE: 'Erstat',
    CORPORATE_CUSTOMERS: 'Virksomhedskunder',
    INVOICE_MENU: 'Faktura',
    INVOICES: 'Fakturaer',
    INVOICE_LIST_SUBTITLE: 'POS-fakturaer, der afventer manuel videresendelse til bogføring.',
    INVOICE_LIST_SEARCH: 'Søg virksomhed, CVR eller faktura…',
    INVOICE_LIST_EMPTY: 'Ingen fakturaer endnu',
    INVOICE_LIST_EMPTY_DESCRIPTION: 'Fakturaer fra POS-fakturabetalinger vises her. Prøv at justere datointerval eller filtre.',
    INVOICE_LIST_LOAD_FAILED: 'Kunne ikke indlæse fakturaer',
    INVOICE_LIST_DATE_RANGE: 'Vælg datointerval',
    INVOICE_LIST_TEXT_SEARCH_HINT: 'Søgningen matcher virksomhed, CVR, fakturanummer og kvitteringsnummer i valgt datointerval (op til 100 seneste fakturaer).',
    INVOICE_LIST_PREVIOUS: 'Forrige',
    INVOICE_LIST_NEXT: 'Næste',
    INVOICE_LIST_PAGE: 'Side',
    INVOICE_STATUS_CREATED: 'Oprettet',
    INVOICE_STATUS_SENT: 'Sendt',
    INVOICE_MARK_SENT: 'Marker som sendt',
    INVOICE_MARKED_SENT: 'Faktura markeret som sendt',
    INVOICE_MARK_SENT_FAILED: 'Kunne ikke opdatere fakturastatus',
    INVOICE_PDF_FAILED: 'Kunne ikke oprette faktura-PDF',
    OPEN_INVOICE: 'Åbn faktura',
    INVOICE_DOWNLOAD_SELECTED: 'Download valgte',
    INVOICE_LOADING_DETAILS: 'Indlæser fakturadetaljer...',
    INVOICE_TITLE: 'Faktura',
    INVOICE_BILL_FROM: 'Faktura fra',
    INVOICE_BILL_TO: 'Faktura til',
    INVOICE_ISSUED_ON: 'Udstedt',
    INVOICE_DETAIL: 'Fakturadetaljer',
    INVOICE_GRAND_TOTAL: 'Samlet total',
    INVOICE_RECEIPT_LINES_UNAVAILABLE: 'Kvitteringslinjer er ikke tilgængelige.',
    INVOICE_RECEIPT_DATA_UNAVAILABLE: 'Kvitteringsdata er ikke tilgængelige',
    INVOICE_NOT_AVAILABLE: 'Ikke tilgængelig',
    INVOICE_CORPORATE_CUSTOMER: 'Virksomhedskunde',
    INVOICE_PAYMENT_METHOD: 'Betalingsmetode',
    INVOICE_GENERATED_ON: 'Genereret',
    INVOICE_PAGE_OF: 'Side {0} af {1}',
    INVOICE_DESCRIPTION: 'Beskrivelse',
    INVOICE_UNIT_PRICE: 'Enhedspris',
    INVOICE_QTY: 'Antal',
    INVOICE_VAT: 'Moms',
    INVOICE_DISCOUNT: 'Rabat',
    INVOICE_TOTAL: 'Total',
    CORPORATE_CUSTOMERS_SUBTITLE: 'Administrer virksomheder og deres leveringslokationer til cateringtjenester.',
    CREATE_CORPORATE_CUSTOMER: 'Opret virksomhedskunde',
    COMPANY_EMAIL: 'Virksomhedens e-mail',
    LOCATIONS: 'Lokationer',
    BILLING_INFO: 'Faktureringsinfo',
    NO_CORPORATE_CUSTOMERS_TITLE: 'Ingen virksomhedskunder endnu',
    NO_CORPORATE_CUSTOMERS_DESCRIPTION: 'Opret din første virksomhedskunde for at administrere faktureringskontakter og leveringslokationer.',
    CREATE_FIRST_CORPORATE_CUSTOMER: 'Opret første virksomhedskunde',
    ORGANIZATION_NUMBER: 'Organisationsnummer',
    ORGANIZATION_ID: 'Organisations-ID',
    EDIT_CORPORATE_CUSTOMER: 'Rediger virksomhedskunde',
    LEGAL_ENTITY_INFORMATION: 'Juridisk enhedsinformation',
    LEGAL_NAME: 'Juridisk navn',
    VAT_NUMBER: 'Momsnummer',
    BILLING_ADDRESS: 'Faktureringsadresse',
    STREET_ADDRESS: 'Gadeadresse',
    POSTAL_CODE: 'Postnummer',
    INVOICE_SETTINGS: 'Fakturaindstillinger',
    DELIVERY_METHOD: 'Leveringsmetode',
    INVOICE_EMAIL: 'Faktura-e-mail',
    PAYMENT_TERMS_DAYS: 'Betalingsbetingelser (dage)',
    BILLING_CONTACT: 'Kontakt',
    CONTACT_NAME: 'Kontaktnavn',
    ADDED_LOCATIONS: 'Tilføjede lokationer',
    ADD_DELIVERY_LOCATION: 'Tilføj leveringslokation',
    FLOOR: 'Etage',
    ENTRANCE_CODE: 'Adgangskode',
    DEFAULT_REFERENCE: 'Standardreference',
    REVIEW_INFORMATION: 'Gennemgå information',
    LEGAL_ENTITY: 'Juridisk enhed',
    PAYMENT_TERMS: 'Betalingsbetingelser',
    SUB_LOCATIONS: 'Underlokationer',
    ADD_SUB_LOCATION: 'Tilføj underlokation',
    ROOM_CODE: 'Rumkode',
    SUB_LOCATION_NAME: 'Underlokationsnavn',
    STEP_COMPANY_INFO: 'Virksomhedsinfo',
    STEP_BILLING_AND_INVOICE: 'Fakturering',
    NO_DELIVERY_LOCATIONS: 'Ingen leveringslokationer endnu',
    CORPORATE_CUSTOMER_CREATED: 'Virksomhedskunde oprettet.',
    CORPORATE_CUSTOMER_UPDATED: 'Virksomhedskunde opdateret.',
    CORPORATE_CUSTOMER_DELETED: 'Virksomhedskunde slettet.',
    CORPORATE_CUSTOMER_SAVE_FAILED: 'Kunne ikke gemme virksomhedskunde.',
    CORPORATE_CUSTOMER_DELETE_FAILED: 'Kunne ikke slette virksomhedskunde.',
    CORPORATE_CUSTOMER_DELETE_CONFIRM: 'Er du sikker på, at du vil slette denne virksomhedskunde?',
    DELETE_CONFIRMATION: 'Bekræft sletning',
    DELIVERY_LOCATIONS_SUBTITLE: 'Leveringslokationer og underlokationer for denne virksomhed',
    BILLING_INFO_SUBTITLE: 'Fakturerings- og fakturainformation for denne virksomhedskunde',

    // Catering Orders – leverings- og fakturadetaljer
    DELIVERY_INFORMATION: 'Leveringsinformation',
    CORPORATE_COMPANY: 'Tilknyttet virksomhed',
    COMPANY_PHONE: 'Virksomhedens telefon',
    DELIVERY_LOCATION: 'Leveringslokation',
    DELIVERY_ROOM: 'Leveringsrum',
    DOOR_CODE: 'Dørkode',
    INVOICE_NUMBER: 'Fakturanummer',
    LOCATION_NAME: 'Lokationsnavn',
    EDIT_LOCATION_AND_SUBLOCATIONS: 'Rediger lokation og underlokationer',
    SUCCEEDED: 'Lykkedes',
    DELIVERY_ROOM_FLOOR: 'Etagenavn',
    DELIVERY_ROOM_DOOR_CODE: 'Rumkode',
    INGREDIENTS: 'Ingredienser',
    INGREDIENTS_DESCRIPTION: 'Vælg ingredienser, der som standard indgår i dette produkt.',
    SELECT_FROM_LIBRARY: 'Vælg fra bibliotek',
    CHOOSE_INGREDIENTS: 'Vælg ingredienser...',
    NO_INGREDIENTS_LIBRARY: 'Ingen ingredienser i biblioteket.',
    CREATE_NEW_INGREDIENT: 'Opret ny ingrediens',
    INGREDIENT_PLACEHOLDER: 'F.eks. Løg',
    INGREDIENT_HINT: 'Tryk på Enter eller klik på + for at tilføje.',
    SELECTED_INGREDIENTS: 'Valgte ingredienser',
    NO_INGREDIENTS_SELECTED: 'Ingen ingredienser valgt endnu.',
    FAILED_LOAD_INGREDIENTS: 'Kunne ikke indlæse ingredienser. Prøv igen.',
    FAILED_CREATE_INGREDIENT: 'Kunne ikke oprette ingrediens. Prøv igen.',
    CONFIRM_DELETE_INGREDIENT: 'Er du sikker på, at du vil slette denne ingrediens permanent fra biblioteket?',
    DELETE_INGREDIENT: 'Slet ingrediens',
    INGREDIENT_DELETED_LIBRARY: 'Ingrediens slettet fra biblioteket.',
    FAILED_DELETE_INGREDIENT: 'Kunne ikke slette ingrediens. Prøv igen.',
    WITHOUT: 'Uden',
    CATERING_ADDON_ERR_DELIVERY_METHOD_REQUIRED: 'Mindst én leveringsmetode skal vælges.',
    CATERING_ADDON_ERR_PRICE_NEGATIVE: 'Pris for tilvalg kan ikke være negativ.',
    NO_DATA: 'Ingen data tilgængelige',
    NO_DATA_HINT: 'Der er i øjeblikket intet at vise.',

    // Catering: no-login order-by-invoice checkout
    GUEST_INVOICE_ORDERING: "Gæstebestilling mod faktura",
    GUEST_INVOICE_ORDERING_DESC: "Aktiverer bestilling mod faktura uden login for denne restaurant. Gæsten angiver virksomheds- og faktureringsoplysninger i kassen i stedet for at betale.",
    CATERING_SHOW_PRICES_EX_VAT: "Vis priser ekskl. moms (B2B)",
    CATERING_SHOW_PRICES_EX_VAT_DESC: "Viser cateringpriser ekskl. moms i webshoppen, med moms og total inkl. moms ved kassen. Kun visning: det opkrævede beløb ændres ikke.",
    // --- Order validation devices ---------------------------------------------
    ORDER_VALIDATION_MENU: 'Ordrevalidering',
    ORDER_VALIDATION_DEVICES: 'Enheder',
    ORDER_VALIDATION_DEVICES_SUBTITLE: 'QR-terminalerne, hvor gæster scanner deres ordre. Ændringer her slår igennem på terminalen af sig selv.',
    ORDER_VALIDATION_DEVICES_TABLE_TITLE: 'Terminaler',
    ORDER_VALIDATION_DEVICES_ADD: 'Tilføj terminal',
    ORDER_VALIDATION_DEVICES_CREATE: 'Opret',
    ORDER_VALIDATION_DEVICES_EDIT: 'Terminalindstillinger',
    ORDER_VALIDATION_DEVICES_NAME: 'Navn',
    ORDER_VALIDATION_DEVICES_NAME_PLACEHOLDER: 'f.eks. Indgangsterminal',
    ORDER_VALIDATION_DEVICES_NAME_REQUIRED: 'Giv terminalen et navn',
    ORDER_VALIDATION_DEVICES_ID: 'Enheds-ID',
    ORDER_VALIDATION_DEVICES_ROUTE: 'Restaurant',
    ORDER_VALIDATION_DEVICES_ROUTE_HELP: 'Enheden, terminalen validerer for. Ordrer fra andre steder afvises.',
    ORDER_VALIDATION_DEVICES_ROUTE_REQUIRED: 'Vælg en restaurant',
    ORDER_VALIDATION_DEVICES_LANGUAGE: 'Sprog',
    ORDER_VALIDATION_DEVICES_LANGUAGE_UNSET: 'Lad terminalen bestemme',
    ORDER_VALIDATION_DEVICES_LANGUAGE_HELP: 'Står det tomt, beholder terminalen det sprog, der er valgt på den.',
    ORDER_VALIDATION_DEVICES_SOUNDS: 'Lyd',
    ORDER_VALIDATION_DEVICES_SOUND_SUCCESS: 'Lyd ved godkendt scanning',
    ORDER_VALIDATION_DEVICES_SOUND_FAILURE: 'Lyd ved afvist scanning',
    ORDER_VALIDATION_DEVICES_VERSION: 'Version',
    ORDER_VALIDATION_DEVICES_LAST_SEEN: 'Sidst set',
    ORDER_VALIDATION_DEVICES_ONLINE: 'Online',
    ORDER_VALIDATION_DEVICES_EMPTY: 'Ingen terminaler endnu. Tilføj en, og indtast dens ID på terminalen.',
    ORDER_VALIDATION_DEVICES_CREATED_HELP: 'Indtast dette ID på terminalen, under PubQ-logoet, for at forbinde den.',
    ORDER_VALIDATION_DEVICES_ID_COPIED: 'Enheds-ID kopieret',
    ORDER_VALIDATION_DEVICES_CREATE_FAILED: 'Kunne ikke oprette terminalen',
    ORDER_VALIDATION_DEVICES_SAVED: 'Terminalindstillinger gemt',
    ORDER_VALIDATION_DEVICES_SAVE_ERROR: 'Kunne ikke gemme terminalindstillingerne',
    ORDER_VALIDATION_DEVICES_LOAD_ERROR: 'Kunne ikke hente terminalerne',
    ORDER_VALIDATION_DEVICES_REMOVE: 'Fjern',
    ORDER_VALIDATION_DEVICES_REMOVE_CONFIRM: 'Fjern terminalen fra enheden?',
    ORDER_VALIDATION_DEVICES_REMOVE_WARNING: 'Terminalen fortsætter med at validere med de indstillinger, den allerede har. At fjerne den her tager den kun ud af listen.',
    ORDER_VALIDATION_DEVICES_REMOVED: 'Terminalen fjernet',
    ORDER_VALIDATION_DEVICES_REMOVE_FAILED: 'Kunne ikke fjerne terminalen',
    // Sidebar labels for the POS section (the screens keep their own titles)
    NAV_POS_BUTTON_LAYER: 'POS-knaplag',
    NAV_POS_DEVICES: 'Enheder',
    NAV_POS_ACTIVITY_LOG: 'Aktivitetslog',
    POS_SETTINGS: 'Indstillinger',
    POS_SETTINGS_SUBTITLE: 'Konfigurer POS-indstillinger for denne enhed.',
    POS_QUICK_RAIL: 'Hurtigmenu',
    POS_QUICK_RAIL_SUBTITLE: 'Konfigurer knappen for åbne produkter, der vises ved siden af kurven i POS V2.',
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED: 'Aktivér åbne produkter',
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED_HINT: 'Vis knappen for åbne produkter i hurtigmenuen i kassen.',
    POS_QUICK_RAIL_OPEN_PRODUCTS: 'Åbne produkter',
    POS_QUICK_RAIL_OPEN_PRODUCTS_HINT: 'Vælg produkter fra produktkataloget, som personalet kan prissætte manuelt.',
    POS_QUICK_RAIL_OPEN_PRODUCTS_EMPTY: 'Ingen åbne produkter valgt endnu. Tilføj produkter ovenfor.',
    POS_QUICK_RAIL_ADD_PRODUCTS: 'Tilføj produkter',
    POS_QUICK_RAIL_DELETE_CONFIRM: 'Er du sikker på, at du vil fjerne "{name}"?',
    POS_QUICK_RAIL_SAVED: 'Hurtigmenu-indstillinger gemt.',
    POS_QUICK_RAIL_SAVE_ERROR: 'Kunne ikke gemme hurtigmenu-indstillinger. Prøv igen.',
    POS_QUICK_RAIL_LOAD_ERROR: 'Kunne ikke indlæse hurtigmenu-indstillinger. Prøv igen.',
    // Integrations + Fortnox (Z): MACHINE-TRANSLATED from Swedish, needs native-Danish review (language.dk-no.REVIEW.md)
    INTEG_TITLE: "Integrationer",
    INTEG_OVERVIEW: "Oversigt",
    INTEG_THIS_RESTAURANT: "restauranten",
    INTEG_LOADING_STATUS: "Henter status…",
    INTEG_COMING_SOON: "Kommer snart",
    INTEG_REAUTH: "Forbindelsen skal godkendes igen",
    INTEG_NOT_CONNECTED: "Ikke forbundet",
    INTEG_NO_ACCESS: "Ingen adgang",
    INTEG_MANAGE: "Administrer",
    INTEG_ACTIVATE: "Aktivér",
    INTEG_DESC_FORTNOX: "Bogfører hver lukket Z-rapport som et bilag i virksomhedens Fortnox. Omkostningssted og kontotilknytning pr. restaurant.",
    INTEG_DESC_PERSONALKOLLEN: "Vagtplanlægning og tidsregistrering: personale, vagter og lønomkostninger synkroniseres med PubQ.",
    INTEG_DESC_TCPOS: "Salgseksport til TCPOS (SOAP / REST) for kæder, der rapporterer i TCPOS.",
    FZ_TITLE: "Fortnox – Z-rapporter",
    FZ_INTRO: "Hver lukket Z-rapport kan bogføres som et bilag i virksomhedens Fortnox.",
    FZ_MODE_MOCK: "TESTTILSTAND (mock): intet sendes til Fortnox, bilagsnumre er opdigtede.",
    FZ_MODE_READONLY: "LÆSETILSTAND: forbindelsen og kontrollerne mod Fortnox virker, men der oprettes ingen bilag.",
    FZ_NO_UNIT: "Ingen restaurant er valgt. Vælg en restaurant i menuen.",
    FZ_NOTICE_CONNECTED: "Fortnox er forbundet for virksomheden.",
    FZ_CONNECTION_HEADER: "Forbindelse (virksomheden)",
    FZ_RETRY: "Prøv igen",
    FZ_CONNECTED_TO: "Forbundet til",
    FZ_DISCONNECT_COMPANY: "Afbryd virksomhedens forbindelse…",
    FZ_BELONGS_TO: "Restauranten tilhører",
    FZ_ORG_MISSING: "CVR-nr. mangler",
    FZ_CONNECT_HELP: "Du logger ind i virksomhedens Fortnox som administrator og godkender. Fortnox-kontoen skal have samme CVR-nummer.",
    FZ_CONNECT: "Forbind Fortnox",
    FZ_DISCONNECTED_OK: "Fortnox afbrudt for virksomheden",
    FZ_LISTS_STILL_SAVE: "du kan stadig gemme indstillingerne.",
    FZ_AUTO_EXPORT: "Automatisk eksport",
    FZ_COST_CENTER: "Omkostningssted",
    FZ_NONE: "– ingen –",
    FZ_LOADING_COST_CENTERS: "Henter omkostningssteder…",
    FZ_NO_COSTCENTER_SCOPE: "Forbindelsen mangler tilladelsen \"omkostningssteder\" – Fortnox kontrollerer koden ved bogføring.",
    FZ_VOUCHER_SERIES: "Bilagsserie",
    FZ_COMPANY_DEFAULT: "– virksomhedens standard –",
    FZ_ROUNDING_ACCOUNT: "Konto for øreafrunding",
    FZ_REVIEW_FIRST: "Gennemgå de første manuelt",
    FZ_ACCOUNT_MAPPING: "Kontotilknytning",
    FZ_ACCOUNT_MAPPING_HELP: "Erstatter en konto fra kassen med en anden konto i Fortnox (eller \"drop\" for linjer uden beløb).",
    FZ_POS_ACCOUNT: "Kassens konto",
    FZ_FORTNOX_ACCOUNT: "Fortnox-konto",
    FZ_ADD_MAPPING: "Tilføj tilknytning",
    FZ_SAVE: "Gem",
    FZ_SETTINGS_SAVED: "Indstillingerne blev gemt",
    FZ_ZREPORTS: "Z-rapporter",
    FZ_COL_BUSINESS_DATE: "Forretningsdag",
    FZ_COL_TOTAL: "I alt",
    FZ_COL_STATUS: "Status",
    FZ_TEST: "test",
    FZ_STATUS_NOT_SENT: "Ikke sendt",
    FZ_STATUS_PENDING: "I kø",
    FZ_STATUS_HELD: "Afventer gennemgang",
    FZ_STATUS_SENDING: "Sendes",
    FZ_STATUS_SENT: "Sendt",
    FZ_STATUS_FAILED: "Mislykkedes",
    FZ_STATUS_LEGACY: "Bogført (gammelt flow)",
    FZ_PREVIEW: "Forhåndsvis",
    FZ_APPROVE_SEND: "Godkend & send",
    FZ_SEND: "Send",
    FZ_RESEND_ELLIPSIS: "Send igen…",
    FZ_EMPTY: "Ingen lukkede Z-rapporter endnu.",
    FZ_BACKFILL_LABEL: "Eftersend Z",
    FZ_FROM: "fra",
    FZ_TO: "til",
    FZ_BACKFILL: "Eftersend",
    FZ_BACKFILL_HELP: "Ældste først. Allerede bogførte springes over. Stopper ved første fejl.",
    FZ_NOT_SENT_BECAUSE: "Sendes ikke:",
    FZ_COL_ACCOUNT: "Konto",
    FZ_COL_TEXT: "Tekst",
    FZ_COL_DEBIT: "Debet",
    FZ_COL_CREDIT: "Kredit",
    FZ_COL_COST_CENTER_SHORT: "OS",
    FZ_SUM: "Sum",
    FZ_CLOSE: "Luk",
    FZ_RESEND_SECOND: "At sende igen opretter et andet bilag for samme dag.",
    FZ_RESEND_VOID_HINT: "Annullér det første i Fortnox, hvis det er forkert.",
    FZ_TYPE_TO_CONFIRM: "Skriv følgende for at bekræfte:",
    FZ_TYPE_ORGNO_TO_CONFIRM: "Skriv CVR-nummeret for at bekræfte:",
    FZ_CANCEL: "Annuller",
    FZ_RESEND: "Send igen",
    FZ_DISCONNECT_TITLE: "Afbryd Fortnox?",
    FZ_DISCONNECT_EFFECT: "Automatisk eksport holder op med at virke, indtil nogen forbinder igen.",
    FZ_DISCONNECT: "Afbryd",
    FZ_ERROR: "Fejl",
    FZ_REFUSED_ALREADY_SENT: "allerede bogført",
    FZ_REFUSED_IN_PROGRESS: "sendes allerede",
    FZ_REFUSED_HELD: "afventer gennemgang",
    FZ_TOAST_MOCK: "TEST – mock",
    FZ_ERR_FORBIDDEN: "Du har ikke adgang til denne restaurant.",
    FZ_ERR_LOAD: "Kunne ikke hentes",
    FZ_ERR_CONNECTION: "Forbindelsen kunne ikke hentes",
    FZ_ERR_LISTS: "Konti og omkostningssteder kunne ikke hentes fra Fortnox",
    FZ_ERR_ZLIST: "Z-rapporterne kunne ikke hentes",
    FZ_ERR_NOT_SIGNED_IN: "Du er ikke logget ind.",
    FZ_ERR_SERVICE_TIMEOUT: "Fortnox-tjenesten svarede ikke i tide",
    FZ_ERR_UNREACHABLE: "Kunne ikke nå Fortnox-tjenesten (netværk eller CORS)",
    // Status page (third-party service status)
    MENU_NAV_STATUS: "Systemstatus",
    MENU_SECTION_OVERVIEW: "Oversigt",
    MENU_SECTION_MENU: "Menu og produkter",
    MENU_SECTION_CHANNELS: "Salgskanaler",
    MENU_SECTION_GUESTS: "Markedsføring",
    MENU_SECTION_ECONOMY: "Økonomi",
    MENU_SECTION_ADMIN: "Administration",
    MENU_SEARCH_PLACEHOLDER: "Søg i menuen",
    MENU_SEARCH_EMPTY: "Ingen sider matcher",
    STATUS_PAGE_TITLE: "Systemstatus",
    STATUS_PAGE_SUBTITLE: "Status for de tredjepartstjenester, jeres enhed bruger",
    PROVIDER_REFRESH: "Opdater",
    PROVIDER_SECTION_TITLE: "Tredjepartstjenester",
    PROVIDER_ISSUES_COUNT: "Tjenester med problemer",
    PROVIDER_ALL_OPERATIONAL: "Alle tjenester kører",
    PROVIDER_LAST_UPDATED: "Opdateret",
    PROVIDER_STATUS_PAGE: "Statusside",
    PROVIDER_FETCH_FAILED: "Kunne ikke hente status",
    PROVIDER_LOADING: "Henter…",
    PROVIDER_EVENTS_TITLE: "Hændelser",
    PROVIDER_NO_EVENTS: "Ingen igangværende, planlagte eller nyligt løste hændelser.",
    PROVIDER_PER_PAGE: "Pr. side:",
    PROVIDER_LEVEL_OPERATIONAL: "I drift",
    PROVIDER_LEVEL_MAINTENANCE: "Vedligeholdelse",
    PROVIDER_LEVEL_DEGRADED: "Forringet",
    PROVIDER_LEVEL_PARTIAL_OUTAGE: "Delvist nedbrud",
    PROVIDER_LEVEL_MAJOR_OUTAGE: "Større nedbrud",
    PROVIDER_LEVEL_UNKNOWN: "Ukendt",
    PROVIDER_EVENT_RESOLVED: "Løst",
    PROVIDER_EVENT_SCHEDULED_MAINTENANCE: "Planlagt vedligeholdelse",
    PROVIDER_EVENT_ONGOING_MAINTENANCE: "Igangværende vedligeholdelse",
    PROVIDER_EVENT_ONGOING_INCIDENT: "Igangværende driftsforstyrrelse",


    // --- Organisation: gruppens tal, delt katalog, delte tilbud ---------------
    ORG_MENU: "Organisation",
    ORG_ORGANISATION: "Organisation",
    ORG_DASHBOARD: "Oversigt",
    ORG_DASHBOARD_SUBTITLE: "Salg for hele gruppen, og pr. enhed.",
    ORG_CATALOG: "Delt produktkatalog",
    ORG_CATALOG_SUBTITLE: "Produkter gruppen deler. Udgivelse skriver til hver enheds egen menu.",
    ORG_CATALOG_HOW_IT_WORKS: "En udgivelse skriver produktet til hver valgt enheds egen menu — derfor journalfører hver kasse sin egen prisændring. Enheder med eget fastlåst pris springes over.",
    ORG_COUPONS: "Delte tilbud",
    ORG_COUPONS_SUBTITLE: "Kuponer og tilbud gruppen deler med sine enheder.",
    ORG_COUPONS_HOW_IT_WORKS: "Definér tilbuddet centralt og del det med de enheder, der skal have det. En enhed kan have sin egen værdi.",
    ORG_ACCESS: "Organisationsadgang",
    ORG_ACCESS_SUBTITLE: "Hvem der ser gruppens tal, og hvem der må administrere dem.",
    ORG_ACCESS_WARNING: "Medlemskab af en organisation giver ikke adgang til gruppens salg. Kun en udtrykkelig rolle her gør det — 841 brugere har allerede en organisationsrække, og de skal ikke se kædens tal ved et uheld.",
    ORG_UNITS: "enheder",
    ORG_UNIT: "Enhed",
    ORG_COMPANIES: "selskaber",
    ORG_PERIOD: "Periode",
    ORG_TOTAL_SALES: "Salg",
    ORG_SALES: "Salg",
    ORG_RECEIPTS: "kvitteringer",
    ORG_AVG_RECEIPT: "Gennemsnitskvittering",
    ORG_SALES_PER_DAY: "Salg pr. dag",
    ORG_SALES_PER_HOUR: "Salg pr. time",
    ORG_PER_UNIT: "Pr. enhed",
    ORG_PAYMENTS: "Betalingsmetoder",
    ORG_PAYMENT_METHOD: "Betalingsmetode",
    ORG_TOP_PRODUCTS: "Mest solgte produkter",
    ORG_PRODUCT: "Produkt",
    ORG_CATEGORY: "Kategori",
    ORG_QUANTITY: "Antal",
    ORG_AMOUNT: "Beløb",
    ORG_COUNT: "Antal",
    ORG_SHARE: "Andel",
    ORG_TOTAL: "Total",
    ORG_NO_DATA: "Ingen data for perioden.",
    ORG_NO_UNITS: "Ingen enheder i denne organisation.",
    ORG_MULTI_CURRENCY: "Gruppen har enheder i flere valutaer. Summerne vises pr. valuta — de lægges aldrig sammen.",
    ORG_UNITS_TRUNCATED: "Flere enheder end et kald rummer. Disse er ikke med:",
    ORG_STATS_UNAVAILABLE: "Statistiktjenesten er ikke slået til i dette miljø.",
    ORG_STATS_FAILED: "Statistikken kunne ikke hentes.",
    ORG_LOAD_FAILED: "Kunne ikke hentes.",
    ORG_SAVE_FAILED: "Kunne ikke gemmes.",
    ORG_ERROR: "Fejl",
    ORG_SAVED: "Gemt",
    ORG_UNITS_SAVED: "Enhederne blev gemt",
    ORG_DEMO_DATA: "DEMODATA",
    ORG_DEMO_DATA_HELP: "Endpointen findes ikke endnu. Det viste er opdigtet og gemmes ikke.",
    ORG_DEMO_NOT_SAVED: "Demodata — intet blev gemt.",
    ORG_LIVE_DATA: "Live data",
    ORG_DERIVED_UNITS: "Egne enheder",
    ORG_DERIVED_UNITS_HELP: "Enhederne er dem du selv er tildelt, grupperet pr. organisation. Serverens egen enhedsliste er ikke klar, så en gruppe kan vise for få enheder.",
    ORG_NEW_PRODUCT: "Nyt produkt",
    ORG_EDIT_PRODUCT: "Redigér produkt",
    ORG_NO_PRODUCTS: "Ingen produkter i kataloget endnu.",
    ORG_NAME: "Navn",
    ORG_DESCRIPTION: "Beskrivelse",
    ORG_BASE_PRICE: "Pris",
    ORG_BASE_PRICE_ORE: "Pris (øre)",
    ORG_VAT: "Moms",
    ORG_SALES_ACCOUNT: "Salgskonto",
    ORG_ACTIVE: "Aktiv",
    ORG_INACTIVE: "Inaktiv",
    ORG_ASSIGNED_UNITS: "Enheder",
    ORG_VERSION: "Version",
    ORG_EDIT: "Redigér",
    ORG_ASSIGN_UNITS: "Vælg enheder",
    ORG_SHARE_WITH_UNITS: "Del med enheder",
    ORG_PUBLISH: "Udgiv",
    ORG_PUBLISH_NOW: "Udgiv nu",
    ORG_PUBLISHED: "Udgivet",
    ORG_UNITS_QUEUED: "enheder i kø",
    ORG_PUBLISH_FAILED: "Udgivelsen mislykkedes.",
    ORG_PREVIEW_FAILED: "Forhåndsvisningen kunne ikke hentes.",
    ORG_ON: "Til",
    ORG_PRICE_OVERRIDE: "Eget pris (øre)",
    ORG_VALUE_OVERRIDE: "Egen værdi",
    ORG_ORG_PRICE: "Gruppens pris",
    ORG_ORG_VALUE: "Gruppens værdi",
    ORG_CLEAR_OVERRIDE: "Fjern egen værdi",
    ORG_WONT_BE_PUBLISHED: "Overskrives ikke",
    ORG_PUBLISHED_LABEL: "Udgivet",
    ORG_OVERRIDE_HELP: "En enheds eget pris overskrives aldrig af en udgivelse. Ryd det, hvis enheden skal følge gruppens pris igen.",
    ORG_COUPON_OVERRIDE_HELP: "En enheds egen værdi gælder før gruppens.",
    ORG_EDIT_NOT_PUBLISHED: "At gemme ændrer kataloget. Enhederne får ændringen først når du udgiver.",
    ORG_WILL_UPDATE: "Opdateres",
    ORG_WILL_SKIP: "Springes over",
    ORG_PUBLISH_JOURNAL_NOTE: "Hver opdateret enhed journalfører sin egen prisændring. Antal journalposter:",
    ORG_PUBLISH_BLOCKED_REGISTER: "Udgivelsen er stoppet: kasseapparat kunne ikke findes for alle enheder, og prisændringen ville så gå igennem uden journalpost. Antal enheder:",
    ORG_PUBLISH_NOTHING: "Intet at udgive — alle enheder er opdaterede.",
    ORG_COUPON: "Tilbud",
    ORG_NEW_COUPON: "Nyt tilbud",
    ORG_EDIT_COUPON: "Redigér tilbud",
    ORG_NO_COUPONS: "Ingen tilbud endnu.",
    ORG_CODE: "Kode",
    ORG_VALUE: "Værdi",
    ORG_VALID: "Gælder",
    ORG_VALID_FROM: "Gælder fra",
    ORG_VALID_TO: "Gælder til",
    ORG_COUPON_KIND: "Type",
    ORG_COUPON_PERCENTAGE: "Procent",
    ORG_COUPON_AMOUNT: "Beløb",
    ORG_COUPON_FREE_ITEM: "Gratis vare",
    ORG_COUPON_PCT_HELP: "0–100",
    ORG_GRANT_ACCESS: "Giv adgang",
    ORG_GRANT: "Giv adgang",
    ORG_REVOKE: "Fjern adgang",
    ORG_REVOKE_CONFIRM: "Fjern organisationsadgang for",
    ORG_ACCESS_GRANTED: "Adgang givet",
    ORG_ACCESS_REVOKED: "Adgang fjernet",
    ORG_USER: "Bruger",
    ORG_ROLE: "Rolle",
    ORG_GRANTED: "Givet",
    ORG_EMAIL: "E-mail",
    ORG_ROLE_ADMIN: "Organisationsadmin",
    ORG_ROLE_VIEWER: "Læser",
    ORG_ROLE_ADMIN_HELP: "ser gruppens salg og administrerer kataloget, tilbuddene og hvem der har adgang.",
    ORG_ROLE_VIEWER_HELP: "ser gruppens salg. Intet andet.",
    ORG_ROLES_EXPLAINED: "Hvad rollerne betyder",
    ORG_ADMIN_ONLY: "Kun en organisationsadmin kan ændre dette.",
    ORG_NO_ACCESS_ROWS: "Ingen har organisationsadgang endnu.",
    ORG_GRANT_EMAIL_HELP: "Brugeren skal allerede findes i PubQ.",
    ORG_GRANT_ADMIN_WARNING: "En organisationsadmin ser hele gruppens salg og kan give andre samme adgang.",

    ORG_STAFF_ACCESS: "PubQ-personale",
    ORG_STAFF_ACCESS_HELP: "Du er logget ind som PubQ-personale og kan åbne enhver organisation.",
    ORG_API_PROBLEM: "API-problem",
    ORG_API_NOT_DEPLOYED: "Organisations-API'et er ikke rullet ud i dette miljø.",
    ORG_FORBIDDEN: "Du har ikke organisationsadgang til denne organisation.",
    ORG_NET: "Netto",
    ORG_NO_SALES: "Intet salg",
    ORG_OTHER_TYPES: "Andre kvitteringer",
    ORG_OTHER_TYPES_HELP: "Kvitteringer der ikke er salg (returneringer, proforma). Rapporteres separat og tælles aldrig med i salget.",
    ORG_SOLD_IN_UNITS: "Enheder",
    ORG_SHOW_ARCHIVED: "Vis arkiverede",
    ORG_ARCHIVED_TAG: "Arkiveret",
    ORG_ARCHIVE: "Arkivér",
    ORG_ARCHIVED: "Arkiveret",
    ORG_ARCHIVE_PUBLISH_NOTE: "Arkiveret i kataloget. Udgiv for at fjerne den fra enhederne.",
    ORG_PRODUCT_TYPE: "Produkttype",
    ORG_CONTAINS_ALCOHOL: "Indeholder alkohol",
    ORG_VAT_ACCOUNT_HINT: "Salgskonto (hint)",
    ORG_VAT_ACCOUNT_HINT_HELP: "Enheder har ofte flere konti for samme momssats (12 % mad og 12 % sodavand). Uden hint eller enhedsvalg nægter udgivelsen at gætte.",
    ORG_SELLABLE: "Sælgbar",
    ORG_SELLABLE_HELP: "Fra betyder at varen findes i enheden men ikke sælges. Den fjernes aldrig.",
    ORG_STALE: "Ikke opdateret",
    ORG_UNITS_IN_SCOPE: "enheder i omfanget",
    ORG_UNCHANGED: "uændrede",
    ORG_WOULD_WITHDRAW: "fjernes",
    ORG_WOULD_FAIL: "mislykkes",
    ORG_WARNINGS: "advarsler",
    ORG_PUBLISH_SOME_FAIL: "Nogle enheder ville mislykkes. Udgivelsen kører for de øvrige — ret disse og udgiv igen.",
    ORG_PUBLISH_QUEUED: "Udgivelse i kø",
    ORG_RUN: "Kørsel",
    ORG_RUN_SWEEP: "hentes inden for 15 min",
    ORG_ENABLED: "Til",
    ORG_DISCOUNT: "Rabat",
    ORG_DISCOUNT_HELP: "1–100 %. Kun procent understøttes i apperne.",
    ORG_OFFER_KIND_CODE: "Rabatkode",
    ORG_OFFER_KIND_OFFER: "Tilbud",
    ORG_CODE_HELP: "A–Z, 0–9, _ og -. 3–50 tegn. Unik blandt organisationens aktive koder.",
    ORG_CODE_CONFLICT: "Koden bruges allerede af et aktivt tilbud i organisationen.",
    ORG_KIND_LOCKED: "Typen kan ikke ændres bagefter.",
    ORG_LIVE_UNITS: "Live",
    ORG_LIVE_NOW: "Live nu",
    ORG_WITHDRAWN: "Fjernet",
    ORG_VALIDITY_ENFORCED: "Gyldighedsperioden styrer udgivelsen: uden for den fjernes koden i hver enhed og lægges tilbage inden for cirka 15 minutter.",
    ORG_OFFER_CONFLICT_NOTE: "En enhed der allerede har sin egen kode med samme tekst får ikke organisationens kode. Enhedens egen kode ændres aldrig.",
    ORG_UNIT_FLAG_NOTE: "Advarsler: apps viser kun koder hvis enheden har kuponkoder slået til, og tilbud kun hvis globale tilbud er slået til. Udgivelsen ændrer ikke enhedens indstillinger.",
    ORG_STAFF_ONLY: "Kun PubQ-personale kan ændre dette.",
    ORG_STAFF_ONLY_NOTE: "Du kan se hvem der har adgang. At give eller fjerne adgang gøres af PubQ-personale — en organisationsadmin kan ikke forfremme andre.",
    ORG_ROLE_STAFF: "PubQ-personale",
    ORG_ROLE_STAFF_HELP: "ser alt, og er de eneste der kan give eller fjerne organisationsadgang.",
    ORG_ACCESS_ALREADY: "Adgang fandtes allerede",
    ORG_USER_NOT_FOUND: "Der findes ingen PubQ-konto med den e-mail. En adgang opretter aldrig en konto.",
    ORG_AUDIT: "Historik",
    ORG_NO_AUDIT: "Ingen historik.",
    ORG_REASON: "Årsag",
    ORG_REASON_HELP: "Gemmes i historikken.",
    ORG_WHEN: "Hvornår",
    ORG_ACTION: "Handling",
    ORG_BY: "Af",

    ORG_MANAGED_TAG: "Organisation",
    ORG_MANAGED_HELP: "Styres af organisationen. Den blev lagt her af en organisationsudgivelse, ikke oprettet i denne enhed.",
    ORG_MANAGED_EDIT_WARNING: "Du kan ændre denne vare, men næste udgivelse fra organisationen overskriver de felter organisationen ejer. Hvis enheden har brug for sin egen pris permanent, bed organisationen om at sætte en undtagelse for enheden.",

    ORG_EXTERNAL_ID: "Eksternt ID",
    ORG_EXTERNAL_ID_HELP: "Varens ID i et andet system, f.eks. Compass Groups TCPOS-varenummer. Sendes til hver enhed og er det felt TCPOS-eksporten læser. Ryd feltet for at fjerne det.",
    ORG_EXTERNAL_ID_KEY: "System",
    ORG_EXTERNAL_ID_OVERRIDE: "Eksternt ID for enheden",
    ORG_WRITTEN: "skrevet",
    ORG_FAILED: "mislykkedes",
    ORG_RETRY: "Prøv igen",
    ORG_PUBLISH_DONE: "Udgivelse færdig",
    ORG_PUBLISH_PARTIAL: "Udgivelse færdig med fejl",
    ORG_RUN_STILL_GOING: "Kørslen er stadig i gang. Den fortsætter i baggrunden — genindlæs senere for at se resultatet.",

    ORG_IMAGE: "Billede",
    ORG_IMAGE_CHOOSE: "Vælg billede",
    ORG_IMAGE_REPLACE: "Skift billede",
    ORG_IMAGE_CLEAR: "Fjern",
    ORG_IMAGE_HELP: "Uploades som organisationens eget billede (org/{id}/products/) og udgives til hver enhed sammen med varen.",

    ORG_IMAGE_NOT_AN_IMAGE: "Filen er ikke et billede.",
    ORG_IMAGE_UPLOAD_FAILED: "Billedet kunne ikke uploades.",
    ORG_IMAGE_DENIED: "Lagringsreglerne afviste skrivningen til organisationens sti. Bed PubQ tilføje reglen for:",

    // --- Send faktura til Fortnox (kladde; aldrig bogført fra PubQ) --------
    FZ_INV_COLUMN: "Fortnox",
    FZ_INV_SEND: "Send til Fortnox",
    FZ_INV_RETRY: "Prøv igen",
    FZ_INV_RESEND: "Send igen",
    FZ_INV_SENDING: "Sender…",
    FZ_INV_FAILED: "Mislykkedes",
    FZ_INV_UNCERTAIN: "Usikker",
    FZ_INV_NOT_SENT: "Ikke sendt",
    FZ_INV_NOT_SENT_YET: "Fakturaen er ikke sendt til Fortnox.",
    FZ_INV_DOC: "Fortnox-faktura",
    FZ_INV_DRAFT_NOTE: "oprettet som ubogført kladde. Bogfør og send den i Fortnox.",
    FZ_INV_SENT_TITLE: "Sendt til Fortnox",
    FZ_INV_ALREADY_TITLE: "Findes allerede i Fortnox",
    FZ_INV_FAILED_TITLE: "Fortnox afviste fakturaen",
    FZ_INV_NOT_READY: "Fakturaen kan endnu ikke sendes til Fortnox.",
    FZ_INV_CONFIRM: "Dette opretter en ny ubogført faktura i Fortnox. PubQ bogfører den ikke og sender den ikke til kunden.",
    FZ_INV_CONFIRM_DRIFT: "Fortnox summerer fakturaen en smule anderledes — kontrollér den der.",
    FZ_INV_LINK_CUSTOMER_FIRST: "Kobl kunden til Fortnox først",
    FZ_INV_GO_LINK_CUSTOMER: "Gå til virksomhedskunder",
    FZ_INV_RECONNECT: "Tilslut Fortnox igen for at kunne fakturere",
    FZ_INV_RECONNECT_CTA: "Tilslut Fortnox igen",
    FZ_INV_DISABLED: "Fakturering til Fortnox er ikke aktiveret i dette miljø",
    FZ_INV_NOT_CONNECTED: "Restauranten er ikke tilsluttet Fortnox",
    FZ_INV_IN_PROGRESS: "Fakturaen sendes lige nu",
    FZ_INV_UNCERTAIN_HELP: "En tidligere afsendelse kan allerede have oprettet fakturaen i Fortnox. Kontrollér i Fortnox, før du sender igen.",
    FZ_INV_RESEND_TITLE: "Send fakturaen igen?",
    FZ_INV_RESEND_CONFIRM_LABEL: "Skriv bekræftelsen for at sende igen:",
    FZ_INV_RECONCILE: "Sum i PubQ / i Fortnox",

    // --- Kundeimport fra Fortnox (bogføringssystemet som kilde) -------------
    FZ_CUST_SEARCH_LABEL: "Søg kunde i Fortnox",
    FZ_CUST_SEARCH_PLACEHOLDER: "Navn, kundenummer eller CVR-nummer",
    FZ_CUST_SEARCH_HINT: "Skriv mindst to tegn. Søger blandt kunderne i det tilsluttede Fortnox-selskab.",
    FZ_CUST_INCLUDE_INACTIVE: "Vis også inaktive",
    FZ_CUST_INACTIVE: "inaktiv",
    FZ_CUST_NO_RESULTS: "Ingen kunde i Fortnox matcher søgningen.",
    FZ_CUST_OR_MANUAL: "eller udfyld oplysningerne selv",
    FZ_CUST_PREFILLED_FROM: "Forudfyldt fra Fortnox:",
    FZ_CUST_DISCARD_PICK: "Fjern",
    FZ_CUST_REVIEW_HELP: "Gennemgå og ret oplysningerne, før du gemmer. Der skrives intet til Fortnox — PubQ læser kun kunderegistret.",
    FZ_CUST_REVIEW_TERMS: "Betalingsbetingelsen i Fortnox er ikke et antal dage. 30 dage er udfyldt — kontrollér det.",
    FZ_CUST_REVIEW_EMAIL: "Kunden har ingen e-mailadresse i Fortnox. Udfyld fakturamodtageren selv.",
    FZ_CUST_REVIEW_ORGNO: "Kunden har intet CVR-nummer i Fortnox. Udfyld det selv.",
    FZ_CUST_WILL_CREATE: "Gemmes som en ny virksomhedskunde.",
    FZ_CUST_WILL_LINK: "CVR-nummeret findes allerede som virksomhedskunde. Den kobles til Fortnox-kunden; dine egne oplysninger røres ikke.",
    FZ_CUST_ALREADY_TITLE: "Allerede importeret",
    FZ_CUST_ALREADY_HELP: "Denne Fortnox-kunde er allerede importeret. Åbn den eksisterende kunde, eller brug Opdatér fra Fortnox på den.",
    FZ_CUST_OPEN_EXISTING: "Åbn eksisterende kunde",
    FZ_CUST_CONFLICT_TITLE: "Flere mulige match",
    FZ_CUST_CONFLICT_HELP: "Der findes en virksomhedskunde, som kan være samme virksomhed, men matchet er for svagt til at koble automatisk. Vælg at koble til en af dem, eller at oprette en ny kunde.",
    FZ_CUST_MATCHED_ON: "Matcher på",
    FZ_CUST_LINK_THIS: "Kobl til denne",
    FZ_CUST_CREATE_ANYWAY: "Opret ny kunde alligevel",
    FZ_CUST_CHOOSE_FIRST: "Vælg kobl eller opret ny, før du gemmer.",
    FZ_CUST_IMPORTED: "Virksomhedskunden blev importeret fra Fortnox.",
    FZ_CUST_LINKED: "Virksomhedskunden blev koblet til Fortnox-kunden.",
    FZ_CUST_SOURCE_TAG: "Fortnox",
    FZ_CUST_REFRESH: "Opdatér fra Fortnox",
    FZ_CUST_REFRESH_NO_CHANGE: "Alt var allerede i trit med Fortnox.",
    FZ_CUST_RECONNECT_TITLE: "Kundeimport er ikke aktiveret",
    FZ_CUST_RECONNECT_CTA: "Tilslut Fortnox igen for at aktivere kundeimport",
    FZ_CUST_CONSENT_NOTE: "Tilslutningen giver også PubQ læseadgang til dit kunderegister i Fortnox, så du kan importere kunder. PubQ ændrer aldrig noget der.",
}

